const ReactDataGrid = require('react-data-grid');

const React = require('react');

import Copy from 'copy-to-clipboard';

import GongqiFormItem from './GongqiFormItem';
import FormItemConst from './FormItemConst';

import {GetSelectRecordsStore,SelectAllRecordsStore,GetColumnLengthProperties} from '../stores/CommandStore';
import {DomReadyStore,PopUpDomReadySotre,LookupBeforeCloseStore} from '../stores/DomStores';
import {GetGridInfosStore,UpdateFetchAllIconStore,TabpageUserChangedStore,GetDataGridColumnInfoStore,UpdateDataGridStore,DynamicColumnStore} from '../stores/UtilStores';
import {VerticalSplitterStore,VisibleFalseToTrueStore,GroupSlideStore} from '../stores/ResizeStore';
import {AfterActiveRecordStore,ScrollToAndFocusStore} from '../stores/FocusStore';
import {SelectRecordsStore,RefreshPluginStore} from '../stores/CmdTypeStore';
import MainMenuToggleStore from '../stores/MainMenuToggleStore';
import ToolBarUpdateGridToolBarStore from '../stores/ToolBarUpdateGridToolBarStore';

import RecordsActions from '../actions/RecordsActions';

import FocusActions from '../actions/FocusActions';
import UtilActions from '../actions/UtilActions';
import LookupActions from '../actions/LookupActions';
import {RecordsCmpStore,GroupCurrentRecordChangedStore,RecordAutoSaveCmpStore,RecordsRestoreCmpStore,AutoSaveBeforeStore} from '../stores/RecordsStore';
import {FocusSetStore,AfterNewRecordDataGridFocusSetStore,NotifyDataGridCurrentGroupStore,ClearGridSignedStore} from '../stores/FocusStore';
import {LookupasteriskRefreshStore} from '../stores/LookupStores';

import FormItemUtil from '../utils/FormItemUtil';
import ArrayUtil from '../utils/ArrayUtil';
import Warning from '../utils/Warn';
import StringUtil from '../utils/StringUtil';
import FormItemDecimalDisplay from './display/FormItemDecimalDisplay';
import CommandActions from '../actions/CommandActions';
import AjaxRemoteUtil from '../utils/AjaxRemoteUtil';
import { timingSafeEqual } from 'crypto';
require('../styles/FormItemDataGridStyle.css');

const xmlstring = {
              id:"00025",
              name:"创建人",
              type:"StringEditor",
              Properties:
              {
                Width:{Value:""},
                Height:{Value:""},
                DisplayLength:{Value:20}
              }
            }

const xmldate = {
              id:"00026",
              name:"创建日期",
              type:"DateEditor",
              Properties:
              {
                Width:{Value:""},
                Height:{Value:""},
                DisplayLength:{Value:20}
              }
            }

//对于Flex的DataGrid来讲 即使只设置了百分比宽度 那么也会根据列计算出初始宽度
//ReactDataGri整体始终根据外层div来确定初始宽度 列宽度按设置
class FormItemDataGrid extends GongqiFormItem{
  
  constructor(props) 
  {
    
  	super(props);
    this.classAlias = "FormItemDataGrid";
    this._columns = this.props.columns;



    this.deleteEnabled = true;
    this.addEnabled = true;
    this.saveEnabled = true;this.refreshEnabled = true;this.fetchAllEnabled = true;
  	this.state = { rows:props.initRecords?props.initRecords:[], selectedIndexes: [0], scrollmax:0,
                    visible:this.props.controlVisible,hideInVisible:this.props.hideInVisible,
                    updateMinHeight:-1,containerWidth100:false,columns:this._columns,heightAddon:0,heightAddonDiffer:0};
    this.bottomBarSettings = {selectedRows:true,obtainRows:true,sum:false,count:false};
    //this.unsubscribeResizeStore = ResizeStore.listen(this.onContainerResize.bind(this));
    this.unsubscribeVerticalSplitterStore = VerticalSplitterStore.listen(this.onVerticalSplitterReisze.bind(this));
    this.unsubscribeRecordsCmpStore = RecordsCmpStore.listen(this.onExecuteCmp.bind(this));
    this.unsubscribeGetSelectRecordsStore = GetSelectRecordsStore.listen(this.onGetSelectRecords.bind(this));
    this.unsubscribeGroupCurrentRecordChangedStore = GroupCurrentRecordChangedStore.listen(this.onCurrentRecordChanged.bind(this));
    this.unsubscribeDomStore = DomReadyStore.listen(this.domReady.bind(this));
   
    this.unsubscribeFocusSetStore = FocusSetStore.listen(this.onFocusSet.bind(this));
    this.unsubcribeRecordsRestoreCmpStore = RecordsRestoreCmpStore.listen(this.onRecordsRestoreCmp.bind(this));
    this.unsubscribeNotifyDataGridCurrentGroupStore = NotifyDataGridCurrentGroupStore.listen(this.onNotifyDataGridCurrentGroup.bind(this));
    this.unsubscribeGetGridInfosStore = GetGridInfosStore.listen(this.onGetGridInfos.bind(this));
    this.unsubscribeUpdateFetchAllIconStore = UpdateFetchAllIconStore.listen(this.onUpdateFetchAllIcon.bind(this));
    this.unsubscribeTabpageUserChangedStore = TabpageUserChangedStore.listen(this.onTabpageUserChanged.bind(this));

    this.unsubscribeVisibleFalseToTrueStore = VisibleFalseToTrueStore.listen(this.onVisibleFalseToTrue.bind(this));
    this.unsubscribeGroupSlideStore = GroupSlideStore.listen(this.onGroupSlide.bind(this));
    this.unsubscribeGetDataGridColumnInfoStore = GetDataGridColumnInfoStore.listen(this.onGetDataGridColumnInfo.bind(this));
    
    if(!this.props.forLookup)
    {
      this.unsubscribeRecordAutoSaveCmpStore = RecordAutoSaveCmpStore.listen(this.onRecordAutoSaveCmp.bind(this));
      this.unsubscribeAfterNewRecordDataGridFocusSetStore = AfterNewRecordDataGridFocusSetStore.listen(this.onAfterNewRecordDataGridFocus.bind(this));
      this.unsubscribeAutoSaveBeforeStore = AutoSaveBeforeStore.listen(this.onBeforeAutoSave.bind(this));
      this.unsubscribeMainMenuToggleStore = MainMenuToggleStore.listen(this.onMainMenuToggleStore.bind(this));
      this.unsubscribeSelectAllRecordsStore = SelectAllRecordsStore.listen(this.onSelectAllRecords.bind(this));
      this.unsubscribeToolBarUpdateGridToolBarStore = ToolBarUpdateGridToolBarStore.listen(this.onUpdateGridToolBar.bind(this));
      this.unsubscribeSelectRecordsStore = SelectRecordsStore.listen(this.onCmdSelectRecords.bind(this));

      this.unsubscribeAfterActiveRecordStore = AfterActiveRecordStore.listen(this.onAfterActiveRecord.bind(this));

      this.unsubscribeGetColumnLengthProperties = GetColumnLengthProperties.listen(this.onGetColumnLengthProperties.bind(this));
      this.unsubscribeScrollToAndFocusStore = ScrollToAndFocusStore.listen(this.onScrollToAndFocus.bind(this));

      this.unsubscribeClearGridSignedStore = ClearGridSignedStore.listen(this.onClearGridSigned.bind(this));

    }
    else
    {
      this.unsubscribeLookupasteriskRefreshStore = LookupasteriskRefreshStore.listen(this.onAsteriskRefresh.bind(this));
      this.unsubscribeLookupBeforeCloseStore = LookupBeforeCloseStore.listen(this.onLookupBeforeClose.bind(this));
    }

    if((window.isPopUp && !this.props.forLookup) || (this.props.isPop && this.props.forLookup))
		{
			this.unsubscribePopUpDomReadySotre = PopUpDomReadySotre.listen(this.onPopUpDomReady.bind(this))
    }
    
    this.unsubscribeUpdateDataGridStore = UpdateDataGridStore.listen(this.onUpdateDataGrid.bind(this));
    this.unsubscribeDynamicColumnStore = DynamicColumnStore.listen(this.onDynamicColumns.bind(this));

    this.unsubscribeRefreshPluginStore = RefreshPluginStore.listen(this.onRefreshRadioPlugin.bind(this));
  }

  onRefreshRadioPlugin(){
    setTimeout(() => {
      this.state['radioRef']=true;
      this.forceUpdate();
      try {
        if(this.props.hasDividedBox){
          if($(this.datagridContainer).find(".react-grid-Grid") && $(this.datagridContainer).find(".react-grid-Grid").length !=0){
            if(this.containerMulFixedHeight){
              $(this.datagridContainer).css("height",this.containerFixedHeight);
            }else{
              var _containerFinalHeight = $(this.datagridContainer).find(".react-grid-Grid").css('min-height')
              _containerFinalHeight =_containerFinalHeight.substring(0,_containerFinalHeight.length-2);
              if($("#app")[0].scrollHeight>$("#app")[0].clientHeight){
                _containerFinalHeight = _containerFinalHeight-($("#app")[0].scrollHeight-$("#app")[0].clientHeight)-2;
              }
              $(this.datagridContainer).css("height",Number(_containerFinalHeight)+50);
              this.containerMulFixedHeight = Number(_containerFinalHeight)+50;
              this.containerFixedHeight = Number(_containerFinalHeight)+50;
            }
          }
        } 
      } catch (error) {
        
      }
      this.state['radioRef']=false;
    }, 200);
  }
  onDynamicColumns(args)
  {
    if(args)
    {
      if(args.key != this.props.groupAlias)
        return;
      let columns = [];
      let dynamicColumnId;
      for(let i = 0;i<this.state.columns.length;i++)
      {
        let column = this.state.columns[i];
        if(column.isdynamic == true)
        {
          dynamicColumnId = column.id;
          continue;
        }
        columns.push(column);
      }
      let origColumnControl;
      let origColumn = args.origColumn;
      let dynamicColumnName = this.props.control.getDynamicColumnName();
      if(dynamicColumnId)
      {
        let controlKey = 
          FormItemUtil.getFormItemControlKey(window.menuItemId,window.formId,dynamicColumnId);
        origColumnControl = FormItemUtil.getFormItemControl(controlKey);
      }
      else
      {
        origColumnControl =  FormItemUtil.formItemControls[menuItemId+"."+formId+"."+dynamicColumnName];
      }
      
      for(let i = 0;i<args.dynamicColumns.length;i++)
      {
        let columnObj = args.dynamicColumns[i];
        let columnLabel = columnObj.columnLabel;
        let columnDataKey = columnObj.dataKey;
        let column = {};
        column.editable = true;
        column.isdynamic = true;
        column.key = args.key+"."+columnDataKey;
        column.name = columnLabel;
        column.skipTab = false;
        column.isDataMethodField = false;
        column.xmlName = origColumnControl.xml.name;
        column.uid = dynamicColumnId + i;
        column.id = dynamicColumnId;
        let _width = origColumnControl.getProperty_Width();
       
        if(_width!=""&&typeof(_width)=="string")_width = parseInt(_width);
        if(!_width)
        {
          let _displayLength=origColumnControl.propertyDisplayLength?origColumnControl.propertyDisplayLength:origColumnControl.getProperty_DisplayLength();
          if(_displayLength == FormItemConst.DATEEDITOR_DEFAULT_DISPLAYLENGTH)_displayLength=FormItemConst.DATEEDITOR_DEFAULT_DISPLAYLENGTH+1;
          column.width=_displayLength*FormItemConst.displayLength_EN+FormItemConst.displayLength_ENAddon;
        }
        else
        {
          column.width = _width;
        }
        column.widthBak = column.width;
        column.resizable = true;
        column.editorType = origColumnControl.xml.type;
        column.formatter = origColumnControl.getRenderForDynamicColumn(column.key);
        column.editor = origColumnControl.getComponentInstanceForDataGrid(null,false);
        column.dynamicFieldName = args.key+"."+origColumn;
        column.dynamicFieldLabel = columnLabel;
        columns.push(column);
      }
      this.setState({columns:columns});
    }
  }

  onGetDataFields()
  {
    
  }

  onUpdateDataGrid(formId,innerId)
  {
    if(this.props.formId == formId && this.props.xml.id == innerId)
      this.forceUpdate();
      let record = this.props.group.currentRecord;
      RecordsActions.dataGridUserChanged(record,this.props.groupAlias,this.props.xml.id,this.props.moduleInstanceId,false);
  }

  onScrollToAndFocus(arg)
  {
      if(!arg)return;
      let groupAlias = arg.groupAlias;
      if(this.props.groupAlias != groupAlias)
        return;
      let toIndex = arg.toIndex;
      let dataField = arg.dataField;
      
      let $container = $(this.datagridContainer);
      let canvas = $container.find(".react-grid-Canvas")[0];
      if(this.checkSelectedIndexOutScreen(toIndex))
      {
        let rowHeight = this.props.rowHeight?this.props.rowHeight:FormItemConst.DATAGRID_ROW_HEIGHT;
        var scrollTopNum = toIndex*rowHeight;
        canvas.scrollTop = scrollTopNum;    
      }

      let hscroll = this.getSelectDataFieldOutScreenOffset(dataField);
      if(hscroll != 0)
      {
        canvas.scrollLeft+=hscroll;
      }
     
      //this.grid.forceUpdate();
      //this.grid.doOnSelect({idx:idx,rowIdx:toIndex,active:false});
      //let _this = this;
     
      setTimeout(function(){
        //_this.grid.doOnSelect({idx:idx,rowIdx:toIndex,active:true});
        //_this.grid.doOnSelect({idx:idx,rowIdx:toIndex,active:false});
        $(canvas).find(".react-grid-Cell.react-grid-cell-signed").removeClass("react-grid-cell-signed");
        let selectedRow = $(canvas).find(".react-grid-Row[data-index="+toIndex+"]");
        let cells = $(selectedRow).find(".react-grid-Cell");
        for(let i = 0;i<cells.length;i++)
        {
          let dataColumnKey = $(cells[i]).attr("data-columnkey");
          if(dataColumnKey == dataField)
          {
            $(cells[i]).addClass("react-grid-cell-signed");
            return;
          }
        }
       
        /*let domRows = $(canvas).find(".react-grid-Row");
        let selectedRow = domRows.get(toIndex);
        let cells = $(selectedRow).find(".react-grid-Cell");

        cells[idx].focus();*/
      },200);
      
      /*if(selectedRow)
      {
        selectedRows[idx].focus();
      }
      else
      {
          canvas.scrollTo(canvas.scrollLeft,canvas.scrollTop+1);
          let _this = this;
          
          setTimeout(function(){

            let selectedRows = $(_this.datagridContainer).find(".react-grid-Cell.row-selected");
            if(selectedRows.length>0)
            {
              selectedRows[idx].focus();
            }
          }
          ,200);
        }*/
  }

  onClearGridSigned()
  {
    $(this.datagridContainer).find(".react-grid-Cell.react-grid-cell-signed").removeClass("react-grid-cell-signed");
  }


  onGetDataGridColumnInfo(arg)
  {
    if(this.props.xml.id != arg.gridId)
      return;
    let _key = arg.key;let _last = false;let flag = false;
    for(let i = 0;i<this.state.columns.length;i++)
    {
      let _column = this.state.columns[i];
      if(flag == true)
      {
        if(_column.width != -1)
        {
          _last = false;break;
        }
      }
      if(_column.key == _key)
      {
        flag = true;
        if(i == this.state.columns.length - 1)
          _last = true;
      }
    }
    arg.last = _last;
  }

  onPopUpDomReady()
	{
		$(this.datagridContainer).css('width','').css('min-width','');
  }
  
  onGetColumnLengthProperties(arg)
  {
    if(this._columns)
    {
      for(let i = 0;i<this._columns.length;i++)
      {
        let _column = this._columns[i];
        let key = _column.key;
        let $columnDoms = $(this.datagridContainer).find(".react-grid-HeaderCell>div");
        $columnDoms.each(

          function(index)
          {
            if($(this).attr("data-xmlname") == key)
            {
              arg[_column.uid] = {width:$(this).width()+4};
              return false;
            }
          }

        );
    
      }
    }
  }


  componentWillUnmount()
  {
    
    //this.unsubscribeResizeStore();
    
    this.unsubscribeRecordsCmpStore();
    this.unsubscribeGetSelectRecordsStore();
    this.unsubscribeGroupCurrentRecordChangedStore();
    this.unsubscribeDomStore();
    this.unsubscribeFocusSetStore();
    
    this.unsubcribeRecordsRestoreCmpStore();
    
    this.unsubscribeNotifyDataGridCurrentGroupStore();
    this.unsubscribeGetGridInfosStore();
    this.unsubscribeUpdateFetchAllIconStore();
    this.unsubscribeVerticalSplitterStore();
   
    if(!this.props.forLookup)
    {
      this.unsubscribeRecordAutoSaveCmpStore();
      this.unsubscribeAfterNewRecordDataGridFocusSetStore();
      this.unsubscribeAutoSaveBeforeStore();
      this.unsubscribeMainMenuToggleStore();
      this.unsubscribeSelectAllRecordsStore();
      this.unsubscribeToolBarUpdateGridToolBarStore();

      this.unsubscribeAfterActiveRecordStore();
      this.unsubscribeSelectRecordsStore();
      this.unsubscribeGetColumnLengthProperties();
    }
    else
    {
      this.unsubscribeLookupasteriskRefreshStore();
      this.unsubscribeLookupBeforeCloseStore();
    }

    if((window.isPopUp && !this.props.forLookup) || (this.props.isPop && this.props.forLookup))
		{
			this.unsubscribePopUpDomReadySotre();
		}
  }


  onLookupBeforeClose(entityId,innerId)
  {
    let _module = this.props.control.module;
    if(!_module)return;
    let _entityId = _module.entityId;
    let _innerId = _module.innerId;
    if(_entityId != entityId || _innerId != innerId)
      return;
    let canvas = $(this.datagridContainer).find(".react-grid-Canvas")[0];
    if(canvas)canvas.scrollTop=0;

    $(this.recordsInfoLabel).html("");
  }

  onAsteriskRefresh(entityId,innerId,filter)
  {
    let _module = this.props.control.module;
    if(!_module)return;
    let _entityId = _module.entityId;
    let _innerId = _module.innerId;
    if(_entityId != entityId || _innerId != innerId)
      return;
    _module.lookupArg["baseFilter"] = filter;
    let _groupAlias;
    if(this.props.group)
      _groupAlias = this.props.group.groupAlias;

    
    _module.doLookupRefresh({group:_groupAlias,appendFilter:true});
  }

  onCmdUpdateParentControlVisible(menuItemId,formId,names,isLookup)
  {
    if(this.props.control && this.props.forLookup == isLookup && this.props.menuItemId == menuItemId
			&& this.props.formId == formId)
		{
      if(names.indexOf(this.props.xml.name) != -1)
      {
        if(this.grid)
          this.grid.updateMetrics();
      }
    }
    
  }

  isParentControl(names)
  {
    let control = this.props.control;
    let parentControl = control.parentControl;
    while(parentControl && parentControl.classAlias!="FormItemDesignControl")
    {
      if(names.indexOf(parentControl.xml.name) != -1)
      {
        return true;
      }
      parentControl = parentControl.parentControl;
    }
    return false;
  }

  onCmdUpdateControlVisible(menuItemId,formId,names,isLookup)
	{
		if(this.props.control && this.props.forLookup == isLookup && this.props.menuItemId == menuItemId
			&& this.props.formId == formId)
		{

      if(names.indexOf(this.props.xml.name) != -1)
      {
        let finalVisible = this.props.control.getProperty_Visible_Final();

        if(finalVisible == true)
        {
          if(this.state.hideInVisible == true)
          {
            $(this.datagridContainer).css("display","flex"); 
          } 
          else 
          {
            $(this.datagridContainer).css("visibility","visible");
          }
        }
        else
        {
          if(this.state.hideInVisible == true)
          {
            $(this.datagridContainer).css("display","none"); 
          } 
          else 
          {
            $(this.datagridContainer).css("visibility","hidden");
          }
        }
        this.grid.updateMetrics();
        this.setState({visible:finalVisible});
        //this.forceUpdate();

      }
      else
      {
        let _columns = this.state.columns.slice();
        let flag = false;
        for(let i = 0;i<_columns.length;i++)
        {
          let _column = _columns[i];
          let _key = _column.key;
          if(_column.isDataMethodField)
          {
            _key = _column.xmlName;
          }
          else
          {
            _key = StringUtil.convertToEachFirstUpperCase(_key);
            _key = _key.replace(/\./g,"_");
          }
          if(names.indexOf(_key) != -1)
          {
            let controlKey = FormItemUtil.getFormItemControlKey(this.props.menuItemId,this.props.formId,_column.uid);
            let columnControl = FormItemUtil.getFormItemControl(controlKey,this.props.forLookup);
            let finalVisible = columnControl.getProperty_Visible_Final();
            if(!finalVisible)
            {
              _column.width = 0.1;
              _column.visible = false;
              flag = true;
            }
            else
            {
              _column.width = _column.widthBak;
              _column.visible = true;
              flag = true;
            }
          }
        }

        if(flag)
        {
          this.setState({columns:_columns});
          //let that = this;
          //setTimeout(function(){that.grid.forceUpdate();},1000);
          this._columns = _columns;
        }
      }

      if(this.isParentControl(names))
      {
        if(this.grid)
        {
          let _grid = this.grid;
          setTimeout(function(){ _grid.updateMetrics();},100);
        }
      }
			
		}
	}

  onBeforeAutoSave(groupAlias)
  {
    if(groupAlias == this.props.groupAlias)
    {
      if(this.grid && this.grid.state.selected && this.grid.state.selected.idx!=-1 && this.grid.state.selected.rowIdx!=-1)
        this.grid.setInactive();
    }
  }

  onNotifyDataGridCurrentGroup(groupAlias,moduleId)
  {
    if(this.props.moduleInstanceId != moduleId)
      return;
    /*let $headerCell = $(this.datagridContainer).find(".react-grid-HeaderCell");
    if(groupAlias == this.props.groupAlias)
    {
      $headerCell.addClass("dataGridCurrentGroup");
     
      $headerCell.find(".pull-right").removeClass("dataGridPullRightNotCurrentGroup").addClass("dataGridPullRightCurrentGroup");
    }
    else
    {
      $headerCell.removeClass("dataGridCurrentGroup");
     
      $headerCell.find(".pull-right").removeClass("dataGridPullRightCurrentGroup").addClass("dataGridPullRightNotCurrentGroup");
    }*/
    let $headerCell = $(this.datagridContainer).find(".GongqiDataGridNumColHeaderCell");
    if(groupAlias == this.props.groupAlias)
    {
      $headerCell.text("*");
    }
    else
    {
      $headerCell.text(" ");
    }

  }

  onAfterNewRecordDataGridFocus(formId,itemId)
  {
    if(this._columns.length == 0)
      return;
    if(this.props.formId == formId && this.props.xml.id == itemId)
    {
      var _doAfterNewRecordDataGridFocus = this.doAfterNewRecordDataGridFocus.bind(this);
      setTimeout(function(){
         
         _doAfterNewRecordDataGridFocus();
         
      },100);
    }
    
  }

  onAfterActiveRecord(groupAlias)
  {
    if(this.props.groupAlias == groupAlias && this.grid)
    {
      let tmp = window.groupActiveRecordStateObj[groupAlias];
      if(tmp.cutClickEnter == true)
      {
        tmp.cutClickEnter = false;
        this.grid.doOnSelect({rowIdx:tmp.rowIdx,idx:tmp.idx,active:true});
      }
    }
  }

  onUpdateGridToolBar(obj)
  {
    if(obj.groupAlias != this.props.groupAlias)
      return;
    if(obj.del)
    {
      $(this.deleteBtn).css({background:'url(./images/icons/da-del.svg) ',backgroundSize:'110%'})
      this.deleteEnabled = true;
    }
    else
    {
      $(this.deleteBtn).css({background:'url(./images/icons/da-del-not.svg) ',backgroundSize:'110%'});
      this.deleteEnabled = false;
    }

    if(obj.add)
    {
      $(this.addBtn).css({background:'url(./images/icons/da-add.svg) ',backgroundSize:'110%'});
      this.addEnabled = true;
    }
    else
    {
      $(this.addBtn).css({background:'url(./images/icons/da-add-not.svg) ',backgroundSize:'110%'});
      this.addEnabled = false;
    }



    if(obj.save)
    {
      $(this.saveBtn).css({background:'url(./images/icons/da-save.svg) ',backgroundSize:'100%'});
      this.saveEnabled = true;
    }
    else 
    {
      $(this.saveBtn).css({background:'url(./images/icons/da-save-not.svg) ',backgroundSize:'100%'});
      this.saveEnabled = false;
    }

    if(obj.query)
    {
      // $(this.refreshBtn).css({backgroundPositionX:'0px'});
      // $(this.fetchAllBtn).css({backgroundPositionX:'-33px'});
      this.refreshEnabled = true;this.fetchAllEnabled = true;
    }
    else
    {
      // $(this.refreshBtn).css({backgroundPositionX:'-179px'});
      // $(this.fetchAllBtn).css({backgroundPositionX:'-213px'});
      this.refreshEnabled = false;this.fetchAllEnabled = false;
    }

    if(obj.query)
    {
      $(this.refreshBtnI).css({background:'url(./images/icons/ze-refsh.svg) 0px 2px',backgroundSize:'90%'});
      $(this.refreshBtnSpan).css({color:'black'});
      if($(window.parent.document).find('#toolbar_recordRef .icon-container')){
        $(window.parent.document).find('#toolbar_recordRef .icon-container').css({background: 'url(./images/icons/ze-ref.svg) 0px 2px no-repeat'});
        $(window.parent.document).find('#toolbar_recordRef .menubtnLable').css({color:'black'});

      }
    }
    else
    {
      $(this.refreshBtnI).css({background:'url(./images/icons/da-ref-not.svg) -4px 0px no-repeat'});
      $(this.refreshBtnSpan).css({color:'#9A9A9A'});
      if($(window.parent.document).find('#toolbar_recordRef .icon-container')){
        $(window.parent.document).find('#toolbar_recordRef .icon-container').css({background:'url(./images/icons/ze-ref-not.svg) 0px 2px no-repeat'});
        $(window.parent.document).find('#toolbar_recordRef .menubtnLable').css({color:'#9A9A9A'});

      }
    }
  }

  doAfterNewRecordDataGridFocus()
  {
      let column;let idx;
      idx = 0;
      column = this._columns[0];
      //TODO_ DataGrid 字段 支持 updateControlSkipTab
      let controlKey = FormItemUtil.getFormItemControlKey(this.props.menuItemId,this.props.formId,column.uid);
      let columnControl = FormItemUtil.getFormItemControl(controlKey,this.props.forLookup);
      let sk =false;
      if(columnControl){
        sk = columnControl.getProperty_ActualSkipTab();
      }else{
        sk = column.skipTab;
      }
      let nowIdx = idx;
      while(column.width==0.1 || sk)
      {
        idx+=1;
        if(idx==nowIdx)
        {
          FocusActions.focusChange(this.props.xml,false);
          return;
        }
          
        if(idx >= this._columns.length)
        {
          FocusActions.focusChange(this.props.xml,false);
          return;
        }
        else if(idx < 0)
        {
          FocusActions.focusChange(this.props.xml,false);
          return;
        }
        column = this._columns[idx];
        controlKey = FormItemUtil.getFormItemControlKey(this.props.menuItemId,this.props.formId,column.uid);
        columnControl = FormItemUtil.getFormItemControl(controlKey,this.props.forLookup);
        sk =false;
        if(columnControl){
          sk = columnControl.getProperty_ActualSkipTab();
        }else{
          sk = column.skipTab;
        }
      }


     var rowIdx = this.state.selectedIndexes.length>0?this.state.selectedIndexes[0]:0;
     //alert("onAfterNewRecordDataGridFocus   "+rowIdx);
     let _parentWindow = window.parent.window;
     //TODO自动进入列表之前 grid必须强制update 会造成性能问题 但是如果不这样做 创建出的项编辑器中props的value是上一选中行的
     if(_parentWindow.userSettingEntry.autoEnterList && !window.disableAutoEnterList)
     {
       this.grid.forceUpdate();
       this.grid.doOnSelect({idx:idx+1,rowIdx:rowIdx,active:true});
      return;
     }
     else
     {
        this.grid.doOnSelect({idx:idx+1,rowIdx:rowIdx,active:false});
        let $selectedCells = $(this.datagridContainer).find(".react-grid-Cell.row-selected");
        let columnKey = column.key;
        for(let i = 0;i<$selectedCells.length;i++)
        {
          let selectedCell = $selectedCells[i];
          if($(selectedCell).attr("data-columnKey") == columnKey)
            selectedCell.focus();

        }
     }
  }

  onFocusSet(formId,itemId,pre,init)
  {
    //TODO 对于程序设置焦点来讲 此代码会先发生 而后发生监听的focus事件 而两者均需要设置当前group
    if(this._columns.length==0)
      return;
    var rowIdx = this.grid.state.selected.rowIdx;
    if(this.props.formId == formId && this.props.xml.id == itemId)
    {
      FocusActions.currentGroupSet(this.props.groupAlias,this.props.formId,this.props.xml.id);
      let column;let idx;
      if(pre)
      {
        idx = this._columns.length-1;
        column = this._columns[idx];
      }
      else
      {
        idx = 0;
        column = this._columns[0];
      }
      let nowIdx = idx;
      while(column.width==0.1 || column.skipTab)
      {
        idx+=(pre?-1:1);
        if(idx==nowIdx)
        {
          FocusActions.focusChange(this.props.xml,pre);
          return;
        }
          
        if(idx >= this._columns.length)
        {
          FocusActions.focusChange(this.props.xml,pre);
          return;
        }
        else if(idx < 0)
        {
          FocusActions.focusChange(this.props.xml,pre);
          return;
        }
        column = this._columns[idx];
      }
      //idx++;
      if(init)
      {
        this.initFocus(idx,rowIdx);
        return;
      }
      
      //模拟react datagrid源代码定位流程
      let _parentWindow = window.parent.window;
      if(_parentWindow.userSettingEntry.autoEnterList && !window.disableAutoEnterList && column.editorType != "BooleanEditor")
      {
        let _this = this;
        
        setTimeout(
          function()
          {
            let selectedRows = $(_this.datagridContainer).find(".react-grid-Cell.row-selected");
            if(selectedRows.length==0)
            {
              let canvas = $(_this.datagridContainer).find(".react-grid-Canvas")[0];
              if(canvas && typeof(canvas.scrollTo) == "function")
              {
                canvas.scrollTo(canvas.scrollLeft,canvas.scrollTop+1);
              }
            }
            _this.grid.doOnSelect({idx:idx+1,rowIdx:rowIdx,active:true});
          },
          200
        );
        return;
      }
      else
      {
        this.grid.doOnSelect({idx:idx+1,rowIdx:rowIdx,active:false});
      }
      
      let selectedRows = $(this.datagridContainer).find(".react-grid-Cell.row-selected");
      if(selectedRows.length>0)
      {
        selectedRows[idx].focus();
      }
      else
      {
        let canvas = $(this.datagridContainer).find(".react-grid-Canvas")[0];
        if(canvas && typeof(canvas.scrollTo) == "function")
        {
          canvas.scrollTo(canvas.scrollLeft,canvas.scrollTop+1);
          let _this = this;
          
          setTimeout(function(){

            let selectedRows = $(_this.datagridContainer).find(".react-grid-Cell.row-selected");
            if(selectedRows.length>0)
            {
              selectedRows[idx].focus();
            }
          }
          ,200);
        }
        /*f(this.grid && this.grid.state && this.grid.state.selected)
        {
          selectedRows = $(this.datagridContainer).find(".react-grid-Row");
          if(selectedRows.length>this.grid.state.selected.rowIdx)
          {
            let cell = selectedRows[this.grid.state.selected.rowIdx];
            if(cell)
              cell.focus();
            else
              this.forceUpdate();
          }
          else
          {
            this.forceUpdate();
          }
        }
        else
        {
          this.forceUpdate();
        }*/
        
        /*
        this.waitingInitFocus = true;
        this.waitingInitIdx = idx;
        this.waitingInitRowIdx = rowIdx;*/
      }
    }
  
  }
  
  initFocus(idx,rowIdx)
  {
    this.waitingInitFocus = true;
    this.waitingInitIdx = idx;
    this.waitingInitRowIdx = rowIdx;
  }

  //DATAGRID的初始定位要在DataGrid完成第一次render 并且数据获取 所以要侦听didupdate方法
  componentDidUpdate()
  {
    if(this.waitingInitFocus == true)
    {
     
      this.waitingInitFocus = false;
      var selectedCells = $(this.datagridContainer).find(".react-grid-Cell.row-selected");
      //当首次update但是无焦点 说明XML自动定位到别的控件 此时应该避免选中
      if(selectedCells.length==0)
      {
        //TODO div在datagrid没有数据的情况下 无法获得焦点 只能通过js来复杂实现 是否有必要？
        //$(this.refs["datagridcontainer"+this.props.xml.id]).focus();

        if(this.props.forLookup)
        {
          //this.grid.doOnSelect({idx:1,rowIdx:0,active:false});
          //setTimeout(function(){selectedCells[0].focus();},200);
          this.waitingInitFocus = true;//如果没有定位成功 则继续等待下次更新后定位 由于下拉框 所以风险应该较小
        }

        return;
      }
      
      let idx = this.waitingInitIdx;
      let rowIdx = this.waitingInitRowIdx;

      this.grid.doOnSelect({idx:idx+1,rowIdx:rowIdx,active:false});
      selectedCells[idx].focus();
    }

    /*var containerId = "#datagridcontainer"+this.props.xml.id;
    var reactgridGridId = containerId+" .react-grid-Grid";
    if($(containerId).height() - $(reactgridGridId).height() > 10)
    {
      this.setState({updateMinHeight:$(containerId).height()-2});
    }*/
    
    let ele = $(this.datagridContainer).find(".react-grid-Canvas")[0];
    if(ele)
    {
      if(ele.scrollHeight > (ele.innerHeight || ele.clientHeight))
      {
        $(this.recordFirstBtn).show();$(this.recordLastBtn).show();
      }
      else
      {
        $(this.recordFirstBtn).hide();$(this.recordLastBtn).hide(); 
      }
    }

    /*if(this.state.selectedIndexes && this.state.rows)
    {
      let length = this.state.selectedIndexes.length;
      if(length>0)
      {
        let selectedIndex = this.state.selectedIndexes[length-1];
        let record = this.state.rows[selectedIndex];
        if(record && this.props.control.group.currentRecord != record)
        {
          
        }
      }
      
    }*/
    // $(this.datagridContainer).on('resize', function() {
    //   console.log('Div size changed');
    // })

  }



  onExecuteCmp(data,groupAlias,groupInstance,immediatelyUpdate)
  {
    if(this.props.group == groupInstance && this.props.groupAlias == groupAlias)
    {

      if(this.props.forLookup)
      {
        this.waitingInitFocus = true;
        this.waitingInitIdx = 0;
        this.waitingInitRowIdx = 0;
      }

      
      if(this.testDataGridHideBecauseTabpageHide() == true)
      {
        this.displayNoneingRows = data;
      }
      /*if(data && data.length > 0)
      {
        let item = data[0];
        alert(item.day01);
      }*/
      this.setState({ rows:data, scrollmax:0});

      if(immediatelyUpdate)this.forceUpdate();

    }
  }

  /*onDataFieldChanged(record,dataField,oldValue,newValue,observer)
  {
    this.setState(this.state);
  }*/

  onCurrentRecordChanged(records,record,groupAlias,moduleInstanceId,causeId,groupSource,parms)
  {
    //alert(causeId + this.props.xml.id);
    if(this.props.xml.id == causeId)
    {
      //alert("causeId相等 直接返回"); 
      return;
    }

    RecordsActions.groupCurrentRecordChangedNotGridUserOp(this.props.groupAlias);

    if(this.props.groupAlias != groupAlias || moduleInstanceId != this.props.moduleInstanceId)
      return;
       
    var selectIndex = this.state.rows.indexOf(record);
    if(selectIndex == -1)
      selectIndex = records?records.indexOf(record):-1;
    var length = this.state.selectedIndexes.length;
    var nowSelectIndex = length>0?this.state.selectedIndexes[length-1]:-1;
    //alert("currentRecordChange-->"+selectIndex);
    if(selectIndex != -1 && selectIndex != nowSelectIndex)
    {
      this.setState({selectedIndexes:[selectIndex]});
      this.selectedIndexesList = [selectIndex];
      this.forceUpdate();
    }
    if(this.checkSelectedIndexOutScreen(selectIndex))
    {
      let $container = $(this.datagridContainer);
      let rowHeight = this.props.rowHeight?this.props.rowHeight:FormItemConst.DATAGRID_ROW_HEIGHT;
      var scrollTopNum = selectIndex*rowHeight;
      $container.find(".react-grid-Canvas")[0].scrollTop = scrollTopNum;   
    }  
    if(parms && parms.hasOwnProperty("focus"))
    {
      if(parms.focus == false)
        return;
    }
    //TODO 查询完成在record_First Last中定位要首先确定selectIndex 
    if(this.props.group.isGlobalForehandGroup() && (this.isFocusedOnBody() || this.datagridContainer.contains(document.activeElement)))
    {
      let idx = this.grid.state.selected.idx;
      if(idx<=0)idx = 1;
      if(selectIndex<0)selectIndex=0;
      //$(this.grid).focus();
      let column = this.state.columns[idx-1];
      //this.grid.doOnSelect({idx:idx,rowIdx:selectIndex});
      
      //TODO 考虑所有锁定列
      /*let $selectedCells = $(this.datagridContainer).find(".react-grid-Cell.row-selected");
      if($selectedCells[idx])
        $selectedCells[idx].focus();*/
      
      let $selectedCells = $(this.datagridContainer).find(".react-grid-Cell.row-selected");
      let columnKey = column.key;
      for(let i = 0;i<$selectedCells.length;i++)
      {
        let selectedCell = $selectedCells[i];
        if($(selectedCell).attr("data-columnKey") == columnKey)
          selectedCell.focus();

      }
      return;
      if(idx > 0)
      {
        let $selectedCells = $(this.datagridContainer).find(".react-grid-Cell.row-selected");
        if($selectedCells[idx-1])
          $selectedCells[idx-1].focus();
      }
      else{

        let $selectedCells = $(this.datagridContainer).find(".react-grid-Cell.row-selected");
        if($selectedCells[$selectedCells.length-1])
          $selectedCells[$selectedCells.length-1].focus();
      }
    }
  }

  isFocusedOnBody() 
  {
    return document.activeElement == null || (document.activeElement.nodeName && typeof document.activeElement.nodeName === 'string' && document.activeElement.nodeName.toLowerCase() === 'body');
  }

  checkSelectedIndexOutScreen(selectIndex)
  {
      let $container = $(this.datagridContainer);
      let $canvas = $container.find(".react-grid-Canvas");
      let nowScrollTop = $canvas[0].scrollTop;
      let rowHeight = this.props.rowHeight?this.props.rowHeight:FormItemConst.DATAGRID_ROW_HEIGHT;
      let topOffsetRows =  nowScrollTop/rowHeight;
      if(selectIndex>topOffsetRows)
      {
        let onScreenRows = ($canvas.height())/rowHeight-1;
        return selectIndex>(topOffsetRows+onScreenRows-1);
      }
      return true;
  }

  getSelectDataFieldOutScreenOffset(dataField)
  {
    let firstRow = $(this.datagridContainer).find(".react-grid-Row")[0];
    let _columns = this.state.columns;
    let offset = 0;
    let $canvas =$(this.datagridContainer).find(".react-grid-Canvas");
    let canvasWidth = $canvas.width();
    let nowScrollLeft = $canvas[0].scrollLeft;
    for(let i = 0;i<_columns.length;i++)
    {
      let column = _columns[i];
      let width = column.width;

      let cellDataField = column.key;
      offset+=width;
      if(cellDataField == dataField)
      {

        if(offset < nowScrollLeft)
        {
          return (offset-nowScrollLeft)-120;
        }
        if(offset > (nowScrollLeft+canvasWidth))
        {
          return offset - (nowScrollLeft+canvasWidth) + 60;
        }
        break;
      }
      
    }
    return 0;
  }

  
  gridKeyDown(proxy)
  {
    //console.log(arguments);
    if(proxy!=null && proxy!=undefined && proxy.hasOwnProperty("nativeEvent"))
    {
      let ne = proxy["nativeEvent"];

      if(this.props.forLookup)
      {
        //if(ne.keyCode == 27 && this.grid && this.grid.state.selected && this.grid.state.selected.active)
        //    return;
        if(ne.keyCode == 27 || (ne.ctrlKey && ne.keyCode == 38))
        {
          let module = this.props.control.module;
          let _entityId = module.props.entityId;
          let _innerId = module.props.innerId;
          LookupActions.popDropDownClose(_entityId,_innerId);
          return false;
        }
      }

      //alert(ne.keyCode);
      if(ne.keyCode == 13)
      {
        if(this.grid.state.selected)
        {
          let selectedRowIdx = this.grid.state.selected.rowIdx;
          if(selectedRowIdx != -1 && this.state.selectedIndexes.indexOf(selectedRowIdx) == -1)
            return false;
        }
      }
     
      if(ne.keyCode == 40 || ne.keyCode == 38)
      {
        //if(this.grid.isActive())
        //  return false;
        if(ne.ctrlKey)
          return false;
        let record = null;
        var newSelectIndexes = this.state.selectedIndexes.slice();
        if(newSelectIndexes.length == 0)
        {
          if(this.state.rows.length>0)
          {
            record = ne.keyCode == 40?this.state.rows[0]:this.state.rows[this.state.rows.length-1];
            newSelectIndexes.push(0);
          }
        }
        else
        {
          let lastIndex = newSelectIndexes[newSelectIndexes.length-1];
          let newIndex = ne.keyCode==40?lastIndex+1:lastIndex-1;
          let total = this.state.rows.length;
          if(newIndex>=0&&newIndex<total)
          {
            record = this.state.rows[newIndex];
            newSelectIndexes = [newIndex];
          }
        }

        let oldSelectIndexes = this.state.selectedIndexes;
        let changed = oldSelectIndexes.toString()!=newSelectIndexes.toString();
        if(changed)
        {
          // if(this.grid.isActive())
          // {
          //   this.updateSelectAfterRowUpdate = true;
          //   this.tmpUpdateSelectArg = {selectedIndexes:newSelectIndexes,removed:false,record:record,changed:changed};
          //   return;
          // }
           
          RecordsActions.RecordAutoSave(this.props.groupAlias);
          if(window.rowChangeAutoSaveFail == true)
          {
            window.rowChangeAutoSaveFail = false;
            return;
          }
          //alert("开始换行");
        }

        this.setState({selectedIndexes:newSelectIndexes});
        this.selectedIndexesList = newSelectIndexes;
        if(record != null)
          RecordsActions.dataGridUserChanged(record,this.props.groupAlias,this.props.xml.id,this.props.moduleInstanceId);
        return true;
      }
      else if(ne.ctrlKey && ne.keyCode == 65)
      {
        let allSelectedIndex = [];
        for(let i = 0;i<this.state.rows.length;i++)
        {
          allSelectedIndex[i] = i;
        }
        this.setState({selectedIndexes:allSelectedIndex});
        this.selectedIndexesList = allSelectedIndex;
        ne.preventDefault();
        ne.stopPropagation();
      }
      else if(ne.ctrlKey && ne.keyCode == 67)
      {
        //this.copyText("ddddddddddddddddddddddddddddddddd");
        if(this.grid && this.grid.isActive())
          return;
        let _selectedRecords = [];
        let selectedIndexes = this.selectedIndexesList?this.selectedIndexesList.slice():this.state.selectedIndexes.slice();
        selectedIndexes.sort(function(a,b){return a-b});
        var rows = this.state.rows;
        let _records = this.props.group.isTempTable?rows:this.props.group.records;
        for(let i = 0;i<selectedIndexes.length;i++)
        {
          let _record = _records[selectedIndexes[i]];
          _selectedRecords.push(_record);
        }
        let text = this.props.group.getSpecExportData(_selectedRecords);
        if(text)
        {
          const copyHandler = (e) => {
            e.clipboardData.setData('text/plain', text);
            e.preventDefault();
          };
          document.addEventListener('copy', copyHandler);
          Copy(text);
          document.removeEventListener('copy', copyHandler);
        }
      }
      
      if(ne.keyCode == 32)
      {
        if(this.grid && !this.grid.isActive())
        {
          if(ne.preventDefault){
            ne.preventDefault();
          }
          else if(window.event)
          {
              window.event.returnValue = false;
          }
        }
        
      }
      

      UtilActions.keyDownCast(ne);
    }
  }

  copyText(text, callback)
  { 
    var tag = document.createElement('input');
    tag.setAttribute('id', 'cp_hgz_input');
    tag.value = text;
    document.getElementsByTagName('body')[0].appendChild(tag);
    document.getElementById('cp_hgz_input').select();
    document.execCommand('copy');
    document.getElementById('cp_hgz_input').remove();
    if(callback) {callback(text)}
  }
  
   onSelectAllRecords(value,groupAlias,moduleInstanceId)
   {
      if(this.props.groupAlias != groupAlias)
        return;
      let allSelectedIndex = [];
      if(value == true)
      {
        for(let i = 0;i<this.state.rows.length;i++)
        {
          allSelectedIndex[i] = i;
        }
        this.setState({selectedIndexes:allSelectedIndex}); 
        this.selectedIndexesList = allSelectedIndex;
      }
      else
      {
        this.setState({selectedIndexes:[]}); 
        this.selectedIndexesList = [];
      }
      
   }

  //dataGridUserChanged->FormDataSourceGroup 的 onDataGridUserChanged -> FormDataGrid又侦听到因为要切换当前选中记录
  //    携带gridId                        gridId                                           判断是由自己引起的
  rowClick(index,record,proxy,selected)
  {
    if(index==-1)
      return;
    window.lastFocusUI = this;
    window.lastFocusDataGrid = this;
    if(AjaxRemoteUtil.tokenNum > 0)
    {
      //alert("正在远程 rowClick被阻止");
      return;
    }
    /*let nowTime = new Date().getTime();
    let firstClick = false;
    if(!this.rowClickTimeCache)
    {
      firstClick = true;
      this.rowClickTimeCache = nowTime;
    }

    if(!firstClick && (nowTime - this.rowClickTimeCache < 500))
    {
      this.rowClickTimeCache = nowTime;
      return;
    }
    this.rowClickTimeCache = nowTime;*/
    this.lastSelected = selected;
    var newSelectIndexes;
    let removed = false;
    if(proxy!=null && proxy!=undefined && proxy.hasOwnProperty("nativeEvent"))
    {
      let ne = proxy["nativeEvent"];

      if(ne.shiftKey)
      {
        //let origSelectIndexes = this.state.selectedIndexes;
        if(this.state.selectedIndexes.length>0)
        {
          newSelectIndexes = this.state.selectedIndexes.slice();
          let minIndex = newSelectIndexes[0];let maxIndex = newSelectIndexes[0];
          for(var i in newSelectIndexes)
          {
            if(newSelectIndexes[i]>maxIndex)maxIndex = newSelectIndexes[i];
            if(newSelectIndexes[i]<minIndex)minIndex = newSelectIndexes[i];
          }

          if(index>maxIndex)
          {
            for(i=maxIndex+1;i<=index;i++)
              newSelectIndexes.push(i);
          }
          else if(index<minIndex)
          {
            for(i=minIndex-1;i>=index;i--)
              newSelectIndexes.push(i);
          }
          else
          {
            if(newSelectIndexes.indexOf(index)==-1)
            {
              let lastIndex = newSelectIndexes[newSelectIndexes.length-1];
              newSelectIndexes.push(index);
              for(i=0;i<Math.abs(index-lastIndex);i++)
              {
                if(index<lastIndex)
                {
                  newSelectIndexes.push(index+i);
                }
                else if(lastIndex>index)
                {
                  newSelectIndexes.push(lastIndex+i);
                }
              }
            }
          }
        }
        else
        {
          newSelectIndexes.push(index);
        }
      }
      else if(ne.ctrlKey)
      {
        newSelectIndexes = this.state.selectedIndexes.slice();
        if(newSelectIndexes.indexOf(index)==-1)
        {
          newSelectIndexes.push(index);
        }
        else
        {
          ArrayUtil.removeByValue(newSelectIndexes,index);removed=true;
        }
        //禁止完全取消选中 因为很多功能流程都依赖于选中项 如果去掉可能造成很多不可预知的bug 如保存记录时recId重复
        //新增记录 然后取消选中 换行 此时会导致保存成功 但是DataGrid控件并没有把保存成功的记录更新到状态因为已没有选中项
        if(newSelectIndexes.length==0)
          newSelectIndexes = [index];
      }
      else
      {
        newSelectIndexes = [index];
      }
      //alert(ne.ctrlKey);alert(ne.shiftKey);
    }
    else
    {
      newSelectIndexes = [index];
    }

    let oldSelectIndexes = this.state.selectedIndexes;
    let changed = oldSelectIndexes.toString()!=newSelectIndexes.toString();
    if(changed && !this.props.forLookup)
    {
      if(this.grid&&this.grid.isActive())
      {
        //let editorDom = $("#datagridcontainer"+this.props.xml.id).find(".react-grid-Cell.row-selected input.editor-main");
        //this.grid.forceUpdate();
        this.updateSelectAfterRowUpdate = true;
        this.tmpUpdateSelectArg = {selectedIndexes:newSelectIndexes,removed:removed,record:record,changed:changed};
        return;
      }
      //let disable_autoSave = this.props.control.getProperty_DisableAutoSave();
      /*let disable_autoSave = false;
      if(this.props.group && this.props.group.isTempTable == true)
      {
        disable_autoSave = true;
      }
      disable_autoSave = false;
      let autoSave = true;
     
      if(disable_autoSave == "true" || (typeof(disable_autoSave) == "boolean" && disable_autoSave == true))
      {
        autoSave = false;
      }*/
      let autoSave = true;
      if(autoSave)
      {
        RecordsActions.RecordAutoSave(this.props.groupAlias);
        if(window.rowChangeAutoSaveFail == true)
        {
          window.rowChangeAutoSaveFail = false;
          return;
        }

        /*if(this.state.rows != this.props.control.group.records)
        {
          alert("错误纠正");
        }*/
        //TODO 此处不知为何要做记录的纠正 不知道何种情况会出现state.rows和group.records的不同步
        //但是需要判断临时表的tempRecordsFilter 否则纠正过的record会和state.rows中的record不一样
        //group的currentRecord会和界面上选中的记录不一致,造成严重bug 比如右键详细信息查看的详情跟当前
        //界面上选中记录不一致。
        try
        {
          if(this.state.rows && this.props.control.group.records)
          {
            let recordIndex = this.state.rows.indexOf(record);
            if(recordIndex != -1)
            {
              let _groupRecords = this.props.control.group.records;
              if(this.props.control.group.isTempTable == true)
              {
                if(this.props.control.group.tempRecordsFilter)
                  _groupRecords = this.props.control.group.tempRecordsFilter;
              }
              let nowRecord = _groupRecords[recordIndex];
              if(nowRecord && nowRecord != record)
              {
                record = nowRecord;
                //alert("记录纠正");
              }
            }
          }
          
        }
        catch(e)
        {

        }
      } 
      
      //alert("开始换行");
    }
    
    this.setState({selectedIndexes:newSelectIndexes});  
    this.selectedIndexesList = newSelectIndexes;
    if(removed)
    {
      let lastIndex = newSelectIndexes[newSelectIndexes.length-1];
      record = this.state.rows[lastIndex];

    }
    if(changed)
    {
      //let lastIndex = newSelectIndexes[newSelectIndexes.length-1];
      //let _record = this.state.rows[lastIndex];
      RecordsActions.dataGridUserChanged(record,this.props.groupAlias,this.props.xml.id,this.props.moduleInstanceId,false);
    }
      
    if(this.props.forLookup)
    {
      if(this.props.remoteReturnHandler)
      {
        if(this.props.remoteReturnHandler(record))
          return;
      }

      if(this.props.autoReturnHandler)
      {
        if(this.props.autoReturnHandler(record))
          return;
      }
    }
  }

  getColumns() {
  	let clonedColumns = this._columns.slice();
  	clonedColumns[2].events = {
  	  onClick: (ev, args) => {
  		const idx = args.idx;
  		const rowIdx = args.rowIdx;
  		this.grid.openCellEditor(rowIdx, idx);
  	  }
	 };

	 return clonedColumns;
  }
  
  rowGetter(i) {
    return this.state.rows[i];
  }

  onGetSelectRecords(selectedRecords,groupAlias,moduleInstanceId,containsSelectedRecordKey = false)
  {
    if(this.props.groupAlias == groupAlias && this.props.moduleInstanceId == moduleInstanceId)
    {

      if(containsSelectedRecordKey == true)
      {
        if(!selectedRecords || selectedRecords.length==0)
        {
          var _selectRecordsKeys = []
          CommandActions.getSelectRecordsKey(_selectRecordsKeys,groupAlias,this.props.menuItemId,this.props.formId,moduleInstanceId);
          var _selectRecordsKey = _selectRecordsKeys.length>0?_selectRecordsKeys[0]:null;

          if(_selectRecordsKey)
          {
            for(var i=0;i<this.state.rows.length;i++)
            {
              var item = this.state.rows[i];
              var value = item[_selectRecordsKeys];
              if(value == true || value == "true")
              {
                selectedRecords.push(item);
              }
            }
          }
        }
      }

      if(!selectedRecords || selectedRecords.length==0)
      {
        // var selectedIndexes = this.state.selectedIndexes;
        var selectedIndexes = this.selectedIndexesList?this.selectedIndexesList:this.state.selectedIndexes;
        var rows = this.state.rows;
     
        let _records = this.props.group.isTempTable?rows:this.props.group.records;
        for(let i = 0;i<selectedIndexes.length;i++)
        {
          //TODO检查临时表客户端过滤时 rows是否与group.records一致 如果使用rows 则可能存在
          //自动保存完调用后台二次开发的时候不一致的情况 如buttonOk的recordsave
          let _record = _records[selectedIndexes[i]];//rows[selectedIndexes[i]];
          selectedRecords.push(_record);
        }
      }
    }
  }

  onRowsSelected(rows) {
    alert("trigger rowSelect");
    var newSelectIndexes = [];
    if(!this.props.allowMutiSelect)
    {
      if(rows.length>0)
      {
        let currentRow = rows[rows.length-1];
        //alert(JSON.stringif(currentRow));
        RecordsActions.dataGridUserChanged(currentRow.row,this.props.groupAlias,this.props.xml.id,this.props.moduleInstanceId);
      }
      newSelectIndexes=this.state.selectedIndexes.concat(rows.map(r => r.rowIdx)); 
    }
    else
    {
      var newSelectIndexes = [];
      if(rows.length>0)newSelectIndexes.push(rows[rows.length-1].rowIdx);
    }

    this.setState({selectedIndexes:newSelectIndexes});
    this.selectedIndexesList = newSelectIndexes;
  }

  onRowsDeselected(rows) {
    let rowIndexes = rows.map(r => r.rowIdx);
    let nowSelectIndexes = this.state.selectedIndexes.filter(i => rowIndexes.indexOf(i) === -1 );
    this.setState({selectedIndexes: nowSelectIndexes});
    this.selectedIndexesList = nowSelectIndexes;
    if(nowSelectIndexes.length>0)
    {
      let records = this.state.rows;
      let nowSelectIndex = nowSelectIndexes[nowSelectIndexes.length-1];
      let record = records[nowSelectIndex];
      RecordsActions.dataGridUserChanged(record,this.props.groupAlias,this.props.xml.id,this.props.moduleInstanceId);
    }
    
  }
  
  
  updateReactDataGridHeight(addon)
  {
    return;
    //alert('updateReactDataGridHeight');
    if(addon == undefined)
      addon = 0;
     
     var _height =  $(this.datagridContainer).outerHeight();
     
     _height+=addon;
    
     $("#"+containerId+" .react-grid-Grid").css("min-height",_height);
     $("#"+containerId+" .react-grid-Canvas").css("height",_height);
     this.grid.base.updateMetrics();
  }

  updateReactDataGridWidth()
  {
    this.grid.updateMetrics();
  }

  domReady()
  {
    //this.updateReactDataGridHeight();
    //alert("domready");
    
  }

  componentDidMount() {//组件完成Dom渲染时会被调用
    //this.inertvalId = setInterval(this.updateReactDataGridHeight.bind(this),10);
    // var containerId = 'datagridcontainer'+this.props.xml.id;
    // $(this.refs[containerId]).resize(function(){alert("resize");this.updateReactDataGridHeight();})
     /*var containerId = 'datagridcontainer'+this.props.xml.id;
     var _height =  $(this.refs[containerId]).height();

     var _rows = this.props.xml.Properties.Rows.Value;
     var _initHeight = parseInt(_rows)*35+35;
     if(_height<_initHeight)
        _height = _initHeight;
     $("#"+containerId+" .react-grid-Grid").css("min-height",_height);
     $("#"+containerId+" .react-grid-Canvas").css("height",_height);
     this.grid.base.updateMetrics();*/
      //this.grid.updateMetrics();

    //this.updateReactDataGridHeight();

    //this.grid.base.viewport.setProps({minHeight:_height});
    //this.grid.base.viewport.metricsUpdated();
    //this.grid.base.viewport.canvas.componentDidUpdate();
    //setState(this.grid.base.viewport.getGridState({minHeight:_height}));
    //this.grid.base.viewport.setState({});
    //canvas.setProps({height:_height});
    // this.grid.setProps({minHeight:_height});
    // this.grid.setState({});
    //this.grid.minHeight = _height;
    let _parentWindow = window.parent.window;
    this.grid.clickEnter = _parentWindow.userSettingEntry.autoEnterList && !window.disableAutoEnterList;
    this.grid.groupAlias = this.props.groupAlias;
    $(this.datagridContainer).find(".react-grid-Canvas")
      .contextPopup(this.props.contextMenuData).css({'overflow-y':'auto','overflow-x':'scroll'});
    // console.log(document.body.offsetWidth);
    if(this.props.updateHeightPercent100)
    {
      
      $(this.datagridContainer).css("height","100%");
      setTimeout(
        this.updateReactDataGridHeight.bind(this),100 
      );
    }
    //let $datagridContainer = $(this.datagridContainer);
    //alert($datagridContainer.height());
    //TODO 在DivideBox 下面 高度暂时不给 给了会出滚动条
    if(this.props.hasDividedBox)
    {
      var that = this;
      setTimeout(function(){
        var _containerFinalHeight = $(that.datagridContainer).height();
      
        $(that.datagridContainer).height(_containerFinalHeight-2);
        that.containerFixedHeight = _containerFinalHeight-2;
      },200);
    }

    if(!this.props.showToolbar){
      $(this.bottombarNode).css("display","none");
    }
    /*var containerId = "#datagridcontainer"+this.props.xml.id;
    var reactgridGridId = containerId+" .react-grid-Grid";
    alert($(containerId).height() + "  " + $(reactgridGridId).height());*/

   /*if (window.addEventListener) {
    window.addEventListener('resize', this.updateMetrics.bind(this));
   } else {
    window.attachEvent('resize', this.updateMetrics.bind(this));
   }*/

   $(this.datagridContainer)
   {
    /*let _outerWidth = $(this.datagridContainer).outerWidth(true);
    let _acWidth = $(this.datagridContainer).width();
    let _offset = _outerWidth - _acWidth;*/

    let rightStr = $(this.datagridContainer).css("padding-right");

    if(!rightStr)rightStr="0px";
    let rightNum = rightStr.substr(0,rightStr.length-2);

    $(this.recordFirstBtn).css("right",rightNum+"px");
    $(this.recordLastBtn).css("right",rightNum+"px");

   }
   
   $(this.bottombarNode).contextPopup(
    {
      selectTag:true,
      items: [
              {label:'已获取行',icon:'',action:this.bottomBarCalc.bind(this,'obtainRows'),checked:true},
              {label:'选中行',icon:'',action:this.bottomBarCalc.bind(this,'selectedRows'),checked:true},
              //{label:'所有行',icon:'',action:this.bottomBarCalc.bind(this,'allRows'),checked:false},
              null,
              {label:'计数',icon:'',action:this.bottomBarCalc.bind(this,'count'),checked:this.bottomBarSettings.count},
              {label:'求和',icon:'',action:this.bottomBarCalc.bind(this,'sum'),checked:this.bottomBarSettings.sum},
              {label:'平均值',icon:'',action:this.bottomBarCalc.bind(this,'avg'),checked:false},
              {label:'最大值',icon:'',action:this.bottomBarCalc.bind(this,'max'),checked:false},
              {label:'最小值',icon:'',action:this.bottomBarCalc.bind(this,'min'),checked:false},
             
            ]  
    });

  }


  bottomBarCalc(key)
  {
    this.bottomBarSettings[key] = !this.bottomBarSettings[key];
    this.updateBottomBar();
  }

  

  updateMetrics()
  {
    //var containerId = 'datagridcontainer'+this.props.xml.id;
    //al/ert($(this.datagridContainer).width() + "   " + this.refs[containerId].offsetWidth);
  }

  onMainMenuToggleStore()
  {
    this.setState({containerWidth100:true});
  }

  onVerticalSplitterReisze(_id,addon)
  {
    if(_id != this.props.xml.id)
      return;

    //如果是由于纵向分隔拖动导致该DataGrid高度发生变化 并且 该DataGrid为高度发生变化的最外层且已经由DividedBox设置了高度 则标记一下
    //以免后续render冲掉该直接操作dom节点设置的高度
    let heightCss = $(this.datagridContainer).css("height");
    if(heightCss)
      this.dividedBoxSplitFixedHeight = heightCss;

    this.containerFixedHeight += addon;
    this.forceUpdate();
    //var that = this;
    //setTimeout(function(){this.grid.base.updateMetrics();},1000);
  }

  onContainerResize(_id,flayout,addon)
  {
    if(_id != this.props.xml.id)
      return;
    if(this.grid != null)
    {
      if(flayout == "horizontal")
      {
        this.updateReactDataGridWidth();
      }
      else if(flayout == "vertical")
      {
        this.forceUpdate();
        if(addon==undefined)
            addon = 0;
        this.updateReactDataGridHeight(addon);
      }
    }
     
  }

  onRecordsRestoreCmp(groupAlias,records,moduleInstanceId)
  {
    if(this.props.groupAlias == groupAlias && this.props.moduleInstanceId == moduleInstanceId)
    {
      this.setState({ rows:records});
    }
  }

  onRecordAutoSaveCmp(groupAlias,record)
  {
    if(this.props.groupAlias != groupAlias)
      return;
    let rows = this.state.rows.slice();
    let nowSelectIndexes = this.state.selectedIndexes;
    let index = nowSelectIndexes[nowSelectIndexes.length-1];
    rows[index] = record;

    this.setState({rows:rows});
    //alert(JSON.stringify("自动保存返回"));
  }
  
  //用来编辑
  handleGridRowsUpdated({cellKey, fromRow, toRow, fromRowId, toRowId, rowIds, updated, action }) {


    /*if(action == "CELL_DRAG")
    {
      window.gridCellDrag = {fromRow:fromRow,toRow:toRow,cellKey:cellKey,gridId:this.props.xml.id,rows:this.state.rows};
      this.forceUpdate();
      return;
    }*/

    //slice为浅表克隆 虽然不会直接修改rows,但此处会修改rows中的元素的字段 即group中的currentRecord
    //所以 如果需要延迟换行做自动保存时 可以判断记录是否已经发生更改
    let rows = this.state.rows.slice(0);
    for (let i = fromRow; i <= toRow; i++) {
      let rowToUpdate = rows[i];
      let updatedRow = $.extend(rowToUpdate,updated);
    //React.addons.update(rowToUpdate, {$merge: updated});
      rows[i] = updatedRow;
    }

    if(this.updateSelectAfterRowUpdate)
    {
      //this.tmpUpdateSelectArg = {selectedIndexes:newSelectIndexes,removed:removed,record:record};
      let newSelectIndexes = this.tmpUpdateSelectArg.selectedIndexes;
      let removed = this.tmpUpdateSelectArg.removed;
      let record = this.tmpUpdateSelectArg.record;
      let changed = this.tmpUpdateSelectArg.changed;
      this.updateSelectAfterRowUpdate = false;
      RecordsActions.RecordAutoSave(this.props.groupAlias);

      if(window.rowChangeAutoSaveFail == true)
      {
        window.rowChangeAutoSaveFail = false;
        return;
      }

      this.setState({selectedIndexes:newSelectIndexes});
      this.selectedIndexesList = newSelectIndexes; 
      //alert("延迟换行");
      if(removed)
      {
        let lastIndex = newSelectIndexes[newSelectIndexes.length-1];
        record = this.state.rows[lastIndex];
      }
      if(changed)
        RecordsActions.dataGridUserChanged(record,this.props.groupAlias,this.props.xml.id,this.props.moduleInstanceId);
    }
    else
    {
      this.setState({ rows:rows });  
    }
    
  }
  
  programSelectRecord()
  {
  	var selectedIndexes = this.state.selectedIndexes.slice();
  	selectedIndexes.push(1);
  	this.setState({selectedIndexes});
  }
  
  getCurrentRecords(){
	  var selectedRows = [];
	  for(var i=0;i<this.state.selectedIndexes.length;i++)
	  {
		  var value = this.state.selectedIndexes[i];
		  var row = this.state.rows[value];
		  selectedRows.push(row);
	  }
	  alert(JSON.stringify(selectedRows));
  }
  
  triggerEdit(){
	  this.grid.openCellEditor(1,4);
  }
  
  scrollToIndex(index){
  	//alert(this.grid.props.rowHeight);
  	if(index == undefined)
  		index = 30;
  	var targetTop = this.grid.props.rowHeight*(index+1);
  	var _dom = this.grid.base.viewport.canvas.rowsContainerDiv;
  	//var scroll_offset = $(_dom).offset(); //得到pos 这个div层的offset，包含两个值，top和left
  	
  	var screenFirstRow = _dom.scrollTop/this.grid.props.rowHeight;
  	var screenLastRow = screenFirstRow+(_dom.clientHeight/this.grid.props.rowHeight);
  	if(index>screenLastRow)
  		targetTop-=_dom.clientHeight;
  	else if(index>screenFirstRow)
  		return;
  	else
  		targetTop-=this.grid.props.rowHeight;
  	var maxScroll = _dom.scrollHeight - _dom.clientHeight;
  	if(targetTop>maxScroll)targetTop = maxScroll;
  	
  	setTimeout(function(){
  			$(_dom).animate({
  			scrollTop:targetTop //让body的scrollTop等于pos的top，就实现了滚动 
  		},10); 
  	},100);
  }
  
  scrollState = {
    scrollTop:0,scrollLeft:0
  };

  scrolling(arg)
  {
    //TODO 当时为了解决在DataGrid只有3行或者4行的情况下，弟4行或者弟5行滚动到 但是会引起滚动条乱跳及滚动时页面闪烁的问题 所以去掉了
    /*if(this.stopOneScroll == true)
    {
      this.stopOneScroll = false;return;
    }*/
    this.canvasScrollBottom = false;
    if(arg.scrollLeft!=this.scrollState.scrollLeft)
    {
      //是横向滚动条 不需要动态加载数据
      this.scrollState.scrollLeft = arg.scrollLeft;
      return;
    }
    // return;
	  console.log("scrolling",arg);
	  var _divdom = arg.dom;
	  if(_divdom)
	  {
		  var scrollTop,maxScroll,minScroll=0;
		  scrollTop = _divdom.scrollTop;
	    maxScroll = _divdom.scrollHeight - _divdom.clientHeight;
      console.log(scrollTop+"------------"+maxScroll);
	    if(scrollTop >= (maxScroll-1))
      {
        this.canvasScrollBottom = true;
        console.log("到底了应该加仓");
        // var addrows = this.createRows(50,50);
        // var rows = this.state.rows.slice();
        // var newrows = rows.concat(addrows);
        // this.setState({rows:newrows,scrollmax:0}); 
	    }
      else if(scrollTop <=0)
      {
		   //alert("滚动到顶了");
		   this.canvasScrollUp = true;
      }
      /*else
      {
        let event = arg.scrollEvent;
        //event.preventDefault();
        //event.stopPropagation();
        this.stopOneScroll = true;
        let rowHeight=this.props.rowHeight?this.props.rowHeight:FormItemConst.DATAGRID_ROW_HEIGHT;
        let detail = 3*rowHeight;
        if(scrollTop + detail > maxScroll)
        {
          detail = maxScroll-scrollTop-1;
        }
        if(this.mouseWheelDetalY>0)
          _divdom.scrollTop += detail;
        else if(this.mouseWheelDetalY<0)
          _divdom.scrollTop -= detail;

      }*/
	  }
  }

  doEnterTab(proxy:SyntheticEvent)
  {
    proxy.preventDefault();
    proxy.stopPropagation();
    var rowIdx = this.grid.state.selected.rowIdx;
    var nowIdx = this.grid.state.selected.idx;
    var nowIdx2 = nowIdx-1;
    var step = 1;
    var pre = false;
    if(proxy!=null && proxy!=undefined && proxy.hasOwnProperty("nativeEvent"))
    {
      let ne = proxy["nativeEvent"];
      ne.preventDefault();
      //ne.onTab
      if(ne.shiftKey)
      {
        step = -1;pre = true;
      }
    }
    var idx = nowIdx2 + step;
   
    if(idx >= this._columns.length)
    {
      idx = 0;
    }
    else if(idx < 0)
    {
      idx = this._columns.length-1;
    }
    
    var column = this._columns[idx];
    let controlKey = FormItemUtil.getFormItemControlKey(this.props.menuItemId,this.props.formId,column.uid);
    let columnControl = FormItemUtil.getFormItemControl(controlKey,this.props.forLookup);
    //对于column 显示隐藏及是否在查询Group下都不用判断 所以直接调用getProperty_ActualSkipTab
    while(column.width==0.1 || column.skipTab || columnControl.getProperty_ActualSkipTab())
    {
      idx+=step;
      if(idx==nowIdx)
      {
        FocusActions.focusChange(this.props.xml,pre);
        return;
      }
        
      if(idx >= this._columns.length)
      {
        idx = 0;
        return;
      }
      else if(idx < 0)
      {
        idx=this._columns.length-1;
        return;
      }
      column = this._columns[idx];
      controlKey = FormItemUtil.getFormItemControlKey(this.props.menuItemId,this.props.formId,column.uid);
      columnControl = FormItemUtil.getFormItemControl(controlKey,this.props.forLookup);
    }
    let _parentWindow = window.parent.window;

    // this.grid.onSelect({ idx: idx+1, rowIdx: rowIdx, active:true });

    if($('.tip-yellowsimple')){
      $('.tip-yellowsimple').remove();
    }
    this.grid.onSelect({ idx: idx+1, rowIdx: rowIdx, active:(columnControl.classAlias=="FormItemBooleanEditorControl"||!_parentWindow.userSettingEntry.autoEnterList)?false:true });
  }

  onEnter(proxy)
  {
  
    if(this.props.forLookup && this.state.selectedIndexes && this.state.selectedIndexes.length>0)
    {
      
      if(!proxy.ctrlKey)
      {
        let selectedIndex = this.state.selectedIndexes[0];
        let record = this.state.rows[selectedIndex];
        if(record)
        {
          if(this.props.remoteReturnHandler)
          {
            if(this.props.remoteReturnHandler(record))
              return true;
          }
          if(this.props.autoReturnHandler)
          {
            if(this.props.autoReturnHandler(record))
              return true;
          }
        }
        
      }
      else
      {
        this.grid.setActive(proxy.key);
        return true;
      }
      
      return false;
    }
    
    let idx = this.grid.state.selected.idx;
    let column = this.grid.getColumn(idx);


    if((column.hasOwnProperty("editable") && !column.editable) || this.grid.isActive())
    {
      this.doEnterTab(proxy);
    }
    else
    {
      this.grid.setActive(proxy.key);
    }
  }
  
  onTab(proxy:SyntheticEvent)
  {
    console.log(proxy);
    proxy.preventDefault();
    proxy.stopPropagation();
    var rowIdx = this.grid.state.selected.rowIdx;
    var nowIdx = this.grid.state.selected.idx;
    var nowIdx2 = nowIdx-1;
    var step = 1;
    var pre = false;
    if(proxy!=null && proxy!=undefined && proxy.hasOwnProperty("nativeEvent"))
    {
      let ne = proxy["nativeEvent"];
      ne.preventDefault();
      //ne.onTab
      if(ne.shiftKey)
      {
        step = -1;pre = true;
      }
    }
    var idx = nowIdx2 + step;
   
    //if(this.grid.isAtLastCellInRow(this.grid.getNbrColumns())) 
    if(idx >= this._columns.length)
    {
      FocusActions.focusChange(this.props.xml,pre);
      return;
    }
    else if(idx < 0)
    {
      FocusActions.focusChange(this.props.xml,pre);
      return;
    }
    
    var column = this._columns[idx];
    let controlKey = FormItemUtil.getFormItemControlKey(this.props.menuItemId,this.props.formId,column.uid);
    let columnControl = FormItemUtil.getFormItemControl(controlKey,this.props.forLookup);
    //对于column 显示隐藏及是否在查询Group下都不用判断 所以直接调用getProperty_ActualSkipTab
    while(column.width==0.1 || column.skipTab || columnControl.getProperty_ActualSkipTab())
    {
      idx+=step;
      if(idx==nowIdx)
      {
        FocusActions.focusChange(this.props.xml,pre);
        return;
      }
        
      if(idx >= this._columns.length)
      {
        FocusActions.focusChange(this.props.xml,pre);
        return;
      }
      else if(idx < 0)
      {
        FocusActions.focusChange(this.props.xml,pre);
        return;
      }
      column = this._columns[idx];
      controlKey = FormItemUtil.getFormItemControlKey(this.props.menuItemId,this.props.formId,column.uid);
      columnControl = FormItemUtil.getFormItemControl(controlKey,this.props.forLookup);
    }
    /*if(column.editable == false)
    {
      this.grid.onSelect({ idx: idx, rowIdx: rowIdx });
    }
    else
    {
      this.grid.openCellEditor(rowIdx,idx);  
    }*/
    let _parentWindow = window.parent.window;
    this.grid.onSelect({ idx: idx+1, rowIdx: rowIdx, active:(columnControl.classAlias=="FormItemBooleanEditorControl"||!_parentWindow.userSettingEntry.autoEnterList)?false:true });
  }
  
  testFocus()
  {
	   $(this.refs['testFocusBtn'])[0].focus();
  }
  
  getStyle()
  {
      let parentLayout = this.props.parentLayout;
      
      let style = {
        //align-items:flex-start,
        //flex-grow:flexGrow
      };
      if(this.props.judgeWidthByColumn)
      {
        let columnWidth = this._columns.length*200-120;
        if(columnWidth>FormItemConst.MAX_DATAGRIDWIDTH)
          columnWidth = FormItemConst.MAX_DATAGRIDWIDTH;
        //alert(FormItemConst.MAX_DATAGRIDWIDTH);
        style["width"] = columnWidth +"px";
      }
      if(parentLayout == "horizontal")
      {
       
        let _width = this.props.xml.Properties.Width.Value;
        if(_width == undefined)
          _width = "";
        let flexGrow = 100;
        let iex = _width.indexOf("%");
        if(iex!=-1)
        { 
          flexGrow = _width.substring(0,iex);
        }

        if(iex==-1&&_width != "")
        {
          style["width"] = _width+"px";
        }
        else
        {
          style["flexGrow"] = flexGrow; 
        }
       
        let _height = this.props.xml.Properties.Height.Value;
        if(_height == undefined)
          _height = "";
        if(_height == "100%" || _height == "")
          style["alignSelf"] = "stretch";
        else if(_height.indexOf("%") != -1)
          style["height"] = _height;
        else if(_height != "")
          style["height"] = _height+"px";

      }
      else //vertical 暂不考虑absolute
      {
        let _height = this.props.xml.Properties.Height.Value;
        if(_height == undefined)
          _height = "";
        let flexGrow = 100;//this.props.xml.Properties.Rows.Value;
        let iex = _height.indexOf("%");
        if(iex!=-1)
        {
          flexGrow = _height.substring(0,iex);
        }
        if(iex==-1&&_height != "")
        {
          flexGrow = _height+"px";
        }
        style["flexGrow"] = flexGrow; 

        

        let _width = this.props.xml.Properties.Width.Value;
        if(_width == undefined)
          _width = "";
        if(_width == "100%" || _width == "")
          style["alignSelf"] = "stretch";
        else if(_width.indexOf("%") != -1)
          style["width"] = _width;
        else if(_width != "")
          style["width"] = _width+"px";
      }
    
      return style;
  }

  testShowHide()
  {
    this.grid.doOnSelect ({ idx: 0, rowIdx: 0,active:true});
    let grid = this.grid;
    setTimeout(function(){grid.doOnSelect ({ idx: 0, rowIdx: 0,active:false})},100);
    return;
    this._columns = this._columns.slice(0);
    var column = this._columns[1];
    if(column.width == 0.1)
    {
      column.width = 100;
      //alert("show");
    } 
    else
    {
      column.width = 0.1;
      //alert("hide");
    }
      
    this.forceUpdate();
    //this.setState();
  }

  onGridCellSelected(selected)
  {
    if(this.props.forLookup)
      return;
    window.lastFocusUI = this;
    window.lastFocusDataGrid = this;
    this.lastSelected = selected;
    if(selected)
    {
      //alert(JSON.stringify(selected));
      let idx = selected.idx - 1;
      if(idx<0)idx = 0;
      let dataField = this.state.columns[idx].key;
      window.lastEditedDataFields[this.props.groupAlias] = dataField;
    }
			
    //window.gridCellDrag = null;
    //$(".gridCellMutiSelected").removeClass("gridCellMutiSelected")
    //alert("onCellSelected");
    if(this.grid.state && this.grid.state.dragged && this.grid.state.dragged.complete == true)
    {
      this.grid.setState({dragged:null});
      $(this.draggedResultLabel).text('');
      //alert("设置complelete null");
    }
    else if(this.grid.state && this.grid.state.dragged)
    {
      //alert("设置compelete true");
      this.grid.setState({dragged:{complete:true}});
      $(this.draggedResultLabel).text('');
    }

  }

  enterMainForm()
  {
    (this.props.control && this.lastSelected)
    {
      let idx = this.lastSelected.idx;
      let columnItem = this._columns[idx-1];
      if(columnItem)
      {
        let _key = columnItem.key;
        let _rowIdx = this.lastSelected.rowIdx;
        let _row = this.state.rows[_rowIdx];
        let _value = _row[_key];
        this.props.control.enterMainForm(this.lastSelected.idx,_value);
      }
      

    }
  }
  ascOrder(){
    if(this.props.control && this.lastSelected)
      this.props.control.ascOrder(this.lastSelected.idx);
  }
  descOrder(){
    if(this.props.control && this.lastSelected)
      this.props.control.descOrder(this.lastSelected.idx);
  }

  findValue()
  {
    if(this.props.control && this.lastSelected)
      this.props.control.findValue(this.lastSelected.idx);
  }
 
  findValue2(flag='')
  {
    if(this.props.control && this.lastSelected)
      this.props.control.findValue2(this.lastSelected.idx,flag);
  }

  enterFind()
  {
    if(this.props.control && this.lastSelected)
      this.props.control.enterFind(this.lastSelected.idx);
  }

  test()
  {
    alert(this.grid == null);
  }

  setLastSelected()
  {
    if(this.lastSelected)
    {
      this.lastSelected.active = false;
      this.grid.doOnSelect(this.lastSelected);
      var selectedCells = $(this.datagridContainer).find(".react-grid-Cell.row-selected");
      if(selectedCells.length==0)
       return;

      let idx = this.lastSelected.idx-1;
      if(idx<0)idx = 0;
      let column = this._columns[idx];
      if(!column)return;

      let columnKey = column.key;
      for(let i = 0;i<selectedCells.length;i++)
      {
        let selectedCell = selectedCells[i];
        if($(selectedCell).attr("data-columnKey") == columnKey)
          selectedCell.focus();

      }
    }
  }

  testOnFocus()
  {
    //TODO 对于tab键导航等程序触发的焦点 存在重复设置当前Group 但无任何影响
    //理论上  程序触发与用户触发都派发该事件 前者情况可以不设置CurrentGroup
    //但是由于前者逻辑较复杂 所以先不改 留待以后观察情况
    //alert("datagrid-focus");
    //console.log("datagrid-focus");
    if(window.testWarnShowedToRemove == true)
    {
      window.testWarnShowedToRemove = false;
      return;
    }

    if(window.testWarnShowing == true)
    {
      return;
    }
    //console.log("ccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccc");
    FocusActions.currentGroupSet(this.props.groupAlias,this.props.formId);
    window.lastFocusDataGrid = this;
  }

  //风险 由mouseDown改为了click 发生时序延后了
  onMouseDownHandler(e)
  {
    FocusActions.currentGroupSet(this.props.groupAlias,this.props.formId);
    if($(e.target).hasClass("GongqiDataGridNumColHeaderCell"))
    {
      let allSelectedIndex = [];
      for(let i = 0;i<this.state.rows.length;i++)
      {
        allSelectedIndex[i] = i;
      }
      if(this.props.group && this.state.rows.length>0){
        this.props.group.currentRecord = this.state.rows[this.state.rows.length-1]
      }
      this.setState({selectedIndexes:allSelectedIndex});
      this.selectedIndexesList = allSelectedIndex;
    }
    if(!$(e.target).hasClass("datagridcontainer_bottombar_more")){
      $(this.moreModelBtns).hide();
    }

  }
  
  onMouseWheel(e)
  {
    if(e.type == "touchmove")
    {
      //let moveEndX = e.changedTouches[0].pageX;
      let moveEndY = e.changedTouches[0].pageY;
      //let X = moveEndX - this.touchStartX;
      let Y =  this.touchStartY - moveEndY;
      this.mouseWheelDetalY = Y;
    }
    else
    {
      this.mouseWheelDetalY = e.deltaY;
    }
    if(this.canvasScrollBottom == true && this.mouseWheelDetalY>0)
    {
      this.canvasScrollBottom = false;
      if(this.props.group)
      {
        if(e.altKey == true)
        {
          this.props.group.recordLast(this.props.groupAlias,this.props.moduleInstanceId);
        }
        else
        {
          this.props.group.scrollEndNextPage();
        }
      }
    }
    else if(this.canvasScrollUp == true && this.mouseWheelDetalY<0)
    {
      this.canvasScrollUp = false;
      if(e.altKey == true)
      {
        this.props.group.recordFirst(this.props.groupAlias,this.props.moduleInstanceId);
      }
      else
      {
        this.props.group.recordPrevPage(false,this.props.groupAlias,this.props.moduleInstanceId);
      }
    }
  }

  nextPageHandler()
  {
    RecordsActions.RecordNextPage(false,this.props.groupAlias,this.props.moduleInstanceId);
  }

  prePageHandler()
  {
    RecordsActions.RecordPrevPage(false,this.props.groupAlias,this.props.moduleInstanceId);
  }

  recordFirstHandler()
  {
    RecordsActions.RecordFirst(this.props.groupAlias,this.props.moduleInstanceId);
  }

  recordLastHandler()
  {
    RecordsActions.RecordLast(this.props.groupAlias,this.props.moduleInstanceId);
  }

  recordRefreshHandler()
  {
    if(!this.refreshEnabled)
      return;
    RecordsActions.RecordRefresh(this.props.groupAlias,this.props.moduleInstanceId);
  }

  recordFetchAllHandler()
  {
    /*var options = 
    {
      text:"确认要获取全部记录吗",
      interacdestroy:false,
      confirm:{isShow:true,event:this.doRecordFetchAll.bind(this)},
      cancel:{isShow:true,event:''}
    };
    Warning.show(options);*/
    if(!this.fetchAllEnabled)
      return;
    this.doRecordFetchAll();
  }
  recordRestore(){
    var group = window.prepareGroupForDoRecord();
    if(group)group.doRecordRestore();
  }

  doRecordFetchAll()
  {
     RecordsActions.RecordFetchAll(this.props.groupAlias,this.props.moduleInstanceId);
  }

  onGetGridInfos(groupAlias,result,moduleInstanceId)
  {
    if(this.props.groupAlias == groupAlias && this.props.moduleInstanceId == moduleInstanceId)
    {
      let linesOnScreen = 0;let $container = $(this.datagridContainer);
      let th = $container.find(".react-grid-Canvas").height();
      let _rowHeight = this.props.rowHeight?this.props.rowHeight:FormItemConst.DATAGRID_ROW_HEIGHT;
      linesOnScreen = (th)/_rowHeight-1;
      if(!result)
        result = {};
      result.linesOnScreen = linesOnScreen;
      let verticalPosition = $container.find(".react-grid-Canvas")[0].scrollTop;
      result.verticalScrollPosition = Math.ceil(verticalPosition/_rowHeight);
    }
  }

  onGroupSlide(arg)
  {
    if(this.grid)
    {
      $(this.datagridContainer).find(".react-grid-Grid").css("min-height",0);
      if(arg != "pre")
        this.grid.updateMetrics();
    }
  }

  onVisibleFalseToTrue()
  {
    this.grid.updateMetrics();
    
  }

  onTabpageUserChanged(arg)
  {
    if(this.props.moduleInstanceId == arg.moduleInstanceId && this.props.xml.id == arg.gridId)
    {
      //有在隐藏期间发生update
      if(this.displayBeforeNoneState)
      {
        //隐藏期间发生过rows的改变
        if(this.displayNoneingRows)
        {
          this.setState({rows:this.displayNoneingRows});
          this.displayNoneingRows = null;
        }
        else
        {

        }
        this.displayBeforeNoneState = null;
        /*if(this.displayBeforeNoneState.rows != this.state.rows)
        {
          this.forceUpdate();
          this.displayBeforeNoneState = null;
        }*/
      }
    }
    //this.forceUpdate();
  }

  onUpdateFetchAllIcon(groupAlias,end,moduleInstanceId)
  {
    if(this.props.groupAlias == groupAlias && this.props.moduleInstanceId == moduleInstanceId)
    {
      if(end == true)//
      {
        $(this.iconFetchAll).removeAttr("style");
        $(this.iconFetchAll).removeClass().addClass("fa fa-check");
        $(this.Btnofall).css("padding", "0 0.2em");
      }
      else
      {
        $(this.iconFetchAll).css("font-size","1.5em");
        $(this.iconFetchAll).removeClass("fa fa-check").addClass("fa fa-level-down");
        $(this.Btnofall).css("padding", "0 0.5em");
      }
    }
  }

  gridMouseMove(e)
  {
    if(e && e.ctrlKey && $(e.target).hasClass("react-grid-HeaderCell"))
    {
      
    }
  }

  onHeaderCellMove(e,col)
  {
    var field = col.key;var totalnum = 0;var _min=0;var _max=0;var index = 0;
    var selectedNumtotal = 0;
    var _selectedIndexes = this.state.selectedIndexes;
    let _selectRecordsKeys = [];let formModule = this.props.control.module;
    CommandActions.getSelectRecordsKey(_selectRecordsKeys,this.props.groupAlias,formModule.menuItemId,formModule.formId,formModule.instanceUUId);
    if(!_selectedIndexes)_selectedIndexes = [];
    let selectedKey;
    if(_selectRecordsKeys && _selectRecordsKeys.length>0)
    {
      selectedKey = _selectRecordsKeys[0];
    }
    for(let i = 0;i<this.state.rows.length;i++)
    {
      let row = this.state.rows[i];
      let value = row[field];
      let num;
      try{
        if(value==null){
          num =0;
        }else{
          if(typeof value =="string"){
            if(value.indexOf(',') != -1){
              value = value.replace(/,/g, "");
            }
            num = parseFloat(value);
          }else{
            num = value;
          }
        }
      }
      catch(e)
      {
        console.log('errror')
        num = 0;
      }

      totalnum+=num;
      if(index == 0)_min=_max=num;
      _min = Math.min(_min,num);
      _max = Math.max(_max,num);
      if(selectedKey)
      {
        if(row[selectedKey] == true)
        {
          selectedNumtotal += num;
        }
      }
      else if(_selectedIndexes.indexOf(i) != -1)
      {
        selectedNumtotal += num;
      }
      index++;
    }
    var _numofdecimals = col.numofdecimals;
    if(_numofdecimals == -1 || !_numofdecimals)_numofdecimals = 0;

    //TODO  如果字段显示千分符  合计也要显示
    let sumv = totalnum.toFixed(_numofdecimals);
    let slsumv=selectedNumtotal.toFixed(_numofdecimals);
    let avgv = (totalnum/(this.state.rows.length>0?this.state.rows.length:1)).toFixed(_numofdecimals);
    let maxv = _max.toFixed(_numofdecimals);
    let minv = _min.toFixed(_numofdecimals);
    let length = this.state.rows.length;
    if(col && col.editorType=="DecimalEditor" && col.formatter.props.thousandSeperator){
      sumv = FormItemDecimalDisplay.getDisplayText(sumv,true,_numofdecimals,true,{});
      slsumv = FormItemDecimalDisplay.getDisplayText(slsumv,true,_numofdecimals,true,{});
      avgv = FormItemDecimalDisplay.getDisplayText(avgv,true,_numofdecimals,true,{});
      maxv = FormItemDecimalDisplay.getDisplayText(maxv,true,_numofdecimals,true,{});
      minv = FormItemDecimalDisplay.getDisplayText(minv,true,_numofdecimals,true,{});
      length = FormItemDecimalDisplay.getDisplayText(length,true,_numofdecimals,true,{});
    }
    var _text = "当前列总和:" + sumv;
    _text+=("\n选中行总和:" + slsumv);
    _text+=("\n平均值"+avgv);
    _text+=("\n最大值"+maxv);
    _text+=("\n最小值"+minv);
    _text+=("\n总记录数"+length);
    return _text;
  }

  onCellsVerticalDragged(dragged)
  {
    this.lastDraggedObject = dragged;
    this.displayCellDraggedResult(dragged);
  }

  onDragHandleDoubleClick(dragged)
  {
    this.lastDraggedObject = dragged;
    this.displayCellDraggedResult(dragged);
  }

  displayCellDraggedResult(args)
  {
    if(!args)return;
    let {cellKey,fromRow,toRow,column,value} = args;
    let isNum = (column.editorType == "LongEditor" || column.editorType == "DecimalEditor");
    let _text = '';
    if(this.bottomBarSettings.count)
      _text+=("计数=" + (toRow-fromRow+1));
    if(isNum)
    {
      let total = 0;
      let numofdecimals = 2;
      if(column.editorType == "DecimalEditor")
      {
        let columnControlKey = FormItemUtil.getFormItemControlKey(window.menuItemId,window.formId,column.uid);
        let columnControl = FormItemUtil.getFormItemControl(columnControlKey,false);
        if(columnControl)
          numofdecimals = columnControl.getProperty_NumOfDecimals();
      }
      let min = 0;let max = 0;
      for(let i = fromRow;i<=toRow;i++)
      {
        let row = this.state.rows[i];
        let value = parseFloat(row[cellKey]);
        if(value<min)min=value;
        if(value>max)max=value;
        total += value;
      }
      if(column.editorType == "DecimalEditor")
        total = total.toFixed(numofdecimals);
      if(this.bottomBarSettings.sum)
      {
        _text+=("  求和="+total);
      }
      
      if(this.bottomBarSettings.avg)
      {
        let count = toRow - fromRow + 1;
        let avg = (total/count).toFixed(2);
        _text+=("  平均值="+avg);
      }
      if(this.bottomBarSettings.min)
      {
        _text+=("  最小值="+min);
      }
      if(this.bottomBarSettings.max)
      {
        _text+=("  最大值="+max);
      }
      
    }
    
    $(this.draggedResultLabel).text(_text);
  }

  recordNewHandler()
  {
    if(!this.addEnabled)
      return;
    this.props.group.doRecordNew();

    var _parentWindow = (typeof(window.setOperate) == 'function')?window:window.parent.window;
    if(_parentWindow.setOperate){
      let remark ={"title":'表格新增内容'};
      var data ={
        'dataArea':'dynamic',
        'userId':_parentWindow.userInfos.userId,
        'userName':_parentWindow.userInfos.userName,
        'clientSessionId':_parentWindow.userInfos.userSessionId,
        'dateTime':new Date().getTime()+'',
        'operationId':'011',
        'formId':formId,
        'formDataSourceName':this.props.groupAlias,
        'formItemName':'',
        'remark':JSON.stringify(remark)
      };
      _parentWindow.setOperate(data);
    }
  }

  recordSaveHandler()
  {
    if(!this.saveEnabled)
      return;
    this.props.group.doRecordSave();
    var _parentWindow = (typeof(window.setOperate) == 'function')?window:window.parent.window;
    if(_parentWindow.setOperate){
      let remark ={"title":'表格保存内容'};
      var data ={
        'dataArea':'dynamic',
        'userId':_parentWindow.userInfos.userId,
        'userName':_parentWindow.userInfos.userName,
        'clientSessionId':_parentWindow.userInfos.userSessionId,
        'dateTime':new Date().getTime()+'',
        'operationId':'012',
        'formId':formId,
        'formDataSourceName':this.props.groupAlias,
        'formItemName':'',
        'remark':JSON.stringify(remark)
      };
      _parentWindow.setOperate(data);
    }
  }

  recordDeleteHandler()
  {
   
    if(!this.deleteEnabled)
      return;
    this.props.group.doRecordDelete();
    var _parentWindow = (typeof(window.setOperate) == 'function')?window:window.parent.window;
    if(_parentWindow.setOperate){
      let remark ={"title":'表格删除内容'};
      var data ={
        'dataArea':'dynamic',
        'userId':_parentWindow.userInfos.userId,
        'userName':_parentWindow.userInfos.userName,
        'clientSessionId':_parentWindow.userInfos.userSessionId,
        'dateTime':new Date().getTime()+'',
        'operationId':'013',
        'formId':formId,
        'formDataSourceName':this.props.groupAlias,
        'formItemName':'',
        'remark':JSON.stringify(remark)
      };
      _parentWindow.setOperate(data);
    }
  }
  dataGridToolbar(){
    $(this.moreModelBtns).show();
  }
    

  onHeaderDragHandleDoubleClick(column)
  {
    let max = column.name.visualLength();
    //let fontSizeRequired = false;
    for(let i = 0;i<this.state.rows.length;i++)
    {
      let item = this.state.rows[i];
      let value = item[column.key];
      if(value)
      {
        let width = value.visualLength();
        if(width>max)
          max = width;
      }
        
    }
    return max>0?max+20:0;
  }

  testDataGridHideBecauseTabpageHide()
  {
    let parent = $(this.datagridContainer).parent();
    while(parent.length>0&&parent[0].localName&&parent[0].localName != 'body'&&parent[0].id != "app")
    {
      if(parent.hasClass("FormItemTabPage") && parent.css("display") == "none" && parent.is(":hidden"))
      {
        return true;
      }
      if(typeof(parent.parent) == "function")
        parent = parent.parent();
      else
        return false;
    }
    return false;
  }

  shouldComponentUpdate(nextProps, nextState)
  {
    if(this.testDataGridHideBecauseTabpageHide() == true)
    {
      if(!this.displayBeforeNoneState)
      {
        this.displayBeforeNoneState = this.state;
      }

      //有查询等导致rows改变的情况 要先清空
      if(this.state.rows.length>0 && this.displayNoneingRows)
      {
        //this.displayNoneingRows = nextState.rows;
        nextState.rows = [];
        return true;
      }

      //this.displayNoneState = nextState;
      return false;
      
    }
    else
    {
      //1、正常情况 应该更新 2、由于切换的时候先发生shouldUpdate 再发生tabChanged tabChanged会判断displayBeforeNoneState 所以清空
      //3、如果是切换的时候 之前有保存的displayNoneingRows 则应该更新掉
      if(this.displayNoneingRows)nextState.rows=this.displayNoneingRows;
      this.displayBeforeNoneState = this.displayNoneingRows = null;
    }
    return true;
  }

  resizeUpdateAssist(type)
  {
    if(type == "resize")
    {
      if($(this.datagridContainer).is(":hidden"))
        return false;
    }

    return true;
  }

  //TODO计划排程 客户端选中记录 为何要延时已经记不清
  onCmdSelectRecords(task)
  {
    //alert(JSON.stringify(task));
    let _this = this;
    setTimeout(function(){

      let _groupAlias = task.group;
      if(_this.props.group.groupAlias == _groupAlias)
      {
        let recIds = task.arg;

        if(typeof(recIds) == "string")
        {
          if(recIds == "all")
          {
            let newIndexes = [];let newSelectedRecords = _this.state.rows;
            for(let i = 0;i<_this.state.rows.length;i++)
            {
              newIndexes.push(i);
            }

            if(newIndexes.length>0)
            {
              _this.setState({selectedIndexes:newIndexes});
              _this.selectedIndexesList = newIndexes;
            }

            let updated = _this.props.group.selectRecords(true,newSelectedRecords);
            //if(updated == true)
            //  _this.grid.forceUpdate();

            return;
          }
          else if(recIds == "none")
          {
            let newIndexes = [];let newSelectedRecords = _this.state.rows;
            _this.setState({selectedIndexes:newIndexes});
            _this.selectedIndexesList = newIndexes;
            _this.props.group.selectRecords(false,newSelectedRecords);
            return;
          }
          else if(recIds == "reverse")
          {
            let newIndexes = [];let newSelectedRecords = _this.state.rows;
            for(let i = 0;i<_this.state.rows.length;i++)
            {
              if(_this.state.selectedIndexes.indexOf(i) == -1)
              {
                newIndexes.push(i);
              }
             
            }
            _this.setState({selectedIndexes:newIndexes});
            _this.selectedIndexesList = newIndexes;
            _this.props.group.reverseSelectedRecords(newSelectedRecords);
            return;
          }
        }

        if(recIds && recIds.length>0)
        {
          let newIndexes = [];let newSelectedRecords = [];
          for(let i = 0;i<_this.state.rows.length;i++)
          {
            let row = _this.state.rows[i];
            let recIdKey = _groupAlias+".recId";
            let recordRecId = row[recIdKey];
            if(recIds.indexOf(recordRecId) != -1)
            {
              let newIndex = _this.state.rows.indexOf(row);
              if(newIndex>-1)
              {
                newSelectedRecords.push(row);
                newIndexes.push(newIndex);
              }
                
            }
          }

          if(newIndexes.length>0)
          {
            _this.setState({selectedIndexes:newIndexes});
            _this.selectedIndexesList = newIndexes;
            _this.props.group.doSelectRecords = newIndexes;
          }
          let updated = _this.props.group.selectRecords(true,newSelectedRecords);
          //if(updated == true)
          //  _this.grid.forceUpdate();

        }
      }


    },500);
    
  }

  onRowDragStart()
  {
    alert("223");
  }

  updateBottomBar()
  {
    var labelContent='';
    if(this.bottomBarSettings.obtainRows)
      labelContent+='已获取'+this.state.rows.slice().length+'行';
    if(this.bottomBarSettings.selectedRows)
      labelContent+=(labelContent?'，选中':'选中')+this.state.selectedIndexes.length+'行';
    if(this.bottomBarSettings.allRows)
    {

    }
    $(this.recordsInfoLabel).text(labelContent);
    this.displayCellDraggedResult(this.lastDraggedObject);
  }

  copyDataCell(){
      var div = document.getElementById('a');
      if (document.body.createTextRange) {
          var range = document.body.createTextRange();
          range.moveToElementText(div);
          range.select();
      } else if (window.getSelection) {
          var selection = window.getSelection();
          var range = document.createRange();
          range.selectNodeContents(div);
          selection.removeAllRanges();
          selection.addRange(range);
          /*if(selection.setBaseAndExtent){
              selection.setBaseAndExtent(text, 0, text, 1);
          }*/
      } else {
          console.warn("none");
      }
      document.execCommand("Copy"); // 执行浏览器复制命令

      alert("已复制好，可贴粘。");
  }

  onTouchStartHandler(e)
  {
    this.touchStartX = e.touches[0].pageX;
    this.touchStartY = e.touches[0].pageY;
  }

  onTouchMoveHandler(e)
  {

  }

  onTouchEndHandler(e)
  {

  }
  datagridmorebtn(){
    $(this.moreModelBtns).hide();
  }

  bottomToolBar(labelContent,update){

    if( update && document.getElementById(this.props.xml.name).offsetWidth<=280){
      return (         
        <div  ref={node=>this.bottombarNode=node} className="datagridcontainer_bottombar" style={{display:'flex',flexDirection:'row',borderLeft:'solid 1px #ddd',borderBottom:'solid 1px #ddd',borderRight:'solid 1px #ddd',minWidth:'190px'}}>

            <label className="datagridcontainer_bottombar_more" ref={node=>this.moreBtn=node} style={{marginTop: '6px',marginLeft: '10px',cursor:'pointer',display:this.props.forLookup?'none':'',width:'17px',background:'url(./images/icons/mb-ellipsis-v-filled.svg)'}} title="" onClick={this.dataGridToolbar.bind(this)}></label>
            <label style={{fontWeight:'400','paddingLeft':'10px',marginTop: '10px',marginBottom: '5px',marginRight: '10px',whiteSpace:'nowrap', overflow:'hidden'}} className={'jon-recorder'} ref={node=>this.recordsInfoLabel=node} >{labelContent}</label>
            <label style={{fontWeight:'400','flexGrow':'100','textAlign': 'right','paddingLeft':'20px',marginTop: '3px',marginBottom: '5px'}} className={'jon-recorder'} ref={node=>this.draggedResultLabel=node} ></label>
            <div className='moreModelBtnsClass' ref={node=>this.moreModelBtns=node} onClick={this.datagridmorebtn.bind(this)} onBlur={this.datagridmorebtn.bind(this)} style={{display:'none',position: 'absolute',bottom: '26px',left: '30px',border: '1px solid #d4d4d4',padding: '10px 0px',backgroundColor: 'white',width:'140px'}}>
            <li className="Ali toolbar_FormSetRf"  style={{ padding: '4px 10px'}}>
                          <a  style={{display:'flex',cursor: 'pointer'}} onClick={this.recordNewHandler.bind(this)}  title="新增">
                            <i   ref={node=>this.addBtn=node} class="icon-container" style={{width:'20px',background:'url(./images/icons/da-add.svg)',backgroundSize:'96%',marginRight: '5px'}}></i>
                            <span class="menubtnLable" style={{color: 'black',fontSize: '15px'}}>新增</span>
                          </a>
              </li>
              <li className="Ali toolbar_FormSetRf"  style={{ padding: '4px 10px'}}>
                          <a  style={{display:'flex',cursor: 'pointer'}} onClick={this.recordSaveHandler.bind(this)}  title="保存">
                            <i  ref={node=>this.saveBtn=node} class="icon-container" style={{width:'18px',height:'18px',marginLeft:'2px',marginTop:'2px',background:'url(./images/icons/da-save.svg)',backgroundSize:'96%',marginRight: '5px'}}></i>
                            <span class="menubtnLable" style={{color: 'black',fontSize: '15px'}}>保存</span>
                          </a>
              </li>
              <li className="Ali toolbar_FormSetRf"  style={{ padding: '4px 10px'}}>
                          <a  style={{display:'flex',cursor: 'pointer'}} onClick={this.recordDeleteHandler.bind(this)}  title="删除">
                            <i  ref={node=>this.deleteBtn=node} class="icon-container" style={{width:'20px',background:'url(./images/icons/da-del.svg)',backgroundSize:'96%',marginRight: '5px'}}></i>
                            <span class="menubtnLable" style={{color: 'black',fontSize: '15px'}}>删除</span>
                          </a>
              </li>
              
              
              <li className="Ali toolbar_FormSetRf"  style={{ padding: '4px 10px'}}>
                          <a ref={node=>this.reStroeBtnH=node} style={{display:'flex',cursor: 'pointer'}} onClick={this.recordRestore.bind(this)}  title="恢复">
                            <i class="icon-container" style={{width:'20px',background:'url(./images/icons/ze-restore.svg)',backgroundSize:'96%',marginRight: '5px'}}></i>
                            <span class="menubtnLable" style={{color: 'black',fontSize: '15px'}}>恢复选中记录</span>
                          </a>
              </li>
              <li className="Ali toolbar_FormSetRf"  style={{ padding: '4px 10px'}}>
                          <a ref={node=>this.refreshBtnH=node} style={{display:'flex',marginTop:'5px',cursor: 'pointer'}} onClick={this.recordRefreshHandler.bind(this)} title="刷新" >
                            <i ref={node=>this.refreshBtnI=node}  class="icon-container"  style={{width:'20px',background:'url(./images/icons/ze-refsh.svg)',backgroundSize:'96%',marginRight: '5px'}}></i>
                            <span ref={node=>this.refreshBtnSpan=node}  class="menubtnLable" style={{color: 'black',fontSize: '15px'}}>重新执行查询</span>
                          </a>
              </li>
              <li className="Ali toolbar_FormSetRf"  style={{ padding: '4px 10px'}}>
                          <a  ref={node=>this.fetchAllBtn=node} style={{display:'flex',marginTop:'5px',cursor: 'pointer'}}  onClick={this.recordFetchAllHandler.bind(this)} title="全取">
                            <i class="icon-container"  style={{width:'20px',background:'url(./images/icons/za-all.svg)',backgroundSize:'96%',marginRight: '5px'}}></i>
                            <span class="menubtnLable" style={{color: 'black',fontSize: '15px'}}>获取全部记录</span>
                          </a>
              </li>
            </div>
  
  
        </div>
  
       )
     

    }else if(update && document.getElementById(this.props.xml.name).offsetWidth<=400){
        return (         
          <div  ref={node=>this.bottombarNode=node} className="datagridcontainer_bottombar" style={{display:'flex',flexDirection:'row',borderLeft:'solid 1px #ddd',borderBottom:'solid 1px #ddd',borderRight:'solid 1px #ddd',minWidth:'221px'}}>
               <label className="datagridcontainer_bottombar_recordnew" ref={node=>this.addBtn=node} style={{marginLeft:'10px',marginTop: '7px',marginBottom: '5px',marginRight: '15px',cursor:'pointer',display:this.props.forLookup?'none':'',width:'20px',background:'url(./images/icons/da-add.svg)',backgroundSize:'110%'}} title="新增" onClick={this.recordNewHandler.bind(this)}></label>
                <label className="datagridcontainer_bottombar_recordsave" ref={node=>this.saveBtn=node} style={{marginTop: '9px',marginBottom: '5px',marginRight: '15px',cursor:'pointer',display:this.props.forLookup?'none':'',width:'18px',background:'url(./images/icons/da-save.svg)',backgroundSize:'100%'}} title="保存" onClick={this.recordSaveHandler.bind(this)}></label>
                <label className="datagridcontainer_bottombar_recorddelelte" ref={node=>this.deleteBtn=node} style={{marginTop: '7px',marginBottom: '5px',marginRight: '15px',cursor:'pointer',display:this.props.forLookup?'none':'',width:'20px',background:'url(./images/icons/da-del.svg)',backgroundSize:'110%'}} title="删除" onClick={this.recordDeleteHandler.bind(this)}></label>
              <label className="datagridcontainer_bottombar_more" ref={node=>this.moreBtn=node} style={{marginTop: '6px',marginLeft: '-5px',cursor:'pointer',display:this.props.forLookup?'none':'',width:'17px',background:'url(./images/icons/mb-ellipsis-v-filled.svg)'}} title="" onClick={this.dataGridToolbar.bind(this)}></label>
              <label style={{fontWeight:'400','paddingLeft':'10px',marginTop: '10px',marginBottom: '5px',marginRight: '10px',whiteSpace:'nowrap', overflow:'hidden'}} className={'jon-recorder'} ref={node=>this.recordsInfoLabel=node} >{labelContent}</label>
              <label style={{fontWeight:'400','flexGrow':'100','textAlign': 'right','paddingLeft':'20px',paddingRight:'20px',marginTop: '3px',marginBottom: '5px'}} className={'jon-recorder'} ref={node=>this.draggedResultLabel=node} ></label>
              <div className='moreModelBtnsClass' ref={node=>this.moreModelBtns=node} onClick={this.datagridmorebtn.bind(this)} onBlur={this.datagridmorebtn.bind(this)} style={{display:'none',position: 'absolute',bottom: '26px',left: '123px',border: '1px solid #d4d4d4',padding: '10px 0px',backgroundColor: 'white',width:'140px'}}>
                <li className="Ali toolbar_FormSetRf"  style={{ padding: '4px 10px'}}>
                            <a ref={node=>this.reStroeBtnH=node} style={{display:'flex',cursor: 'pointer'}} onClick={this.recordRestore.bind(this)}  title="恢复">
                              <i class="icon-container" style={{width:'20px',background:'url(./images/icons/ze-restore.svg)',backgroundSize:'96%',marginRight: '5px'}}></i>
                              <span class="menubtnLable" style={{color: 'black',fontSize: '15px'}}>恢复选中记录</span>
                            </a>
                </li>
                <li className="Ali toolbar_FormSetRf"  style={{ padding: '4px 10px'}}>
                            <a ref={node=>this.refreshBtnH=node} style={{display:'flex',marginTop:'5px',cursor: 'pointer'}} onClick={this.recordRefreshHandler.bind(this)} title="刷新" >
                              <i ref={node=>this.refreshBtnI=node}  class="icon-container"  style={{width:'20px',background:'url(./images/icons/ze-refsh.svg)',backgroundSize:'96%',marginRight: '5px'}}></i>
                              <span ref={node=>this.refreshBtnSpan=node}  class="menubtnLable" style={{color: 'black',fontSize: '15px'}}>重新执行查询</span>
                            </a>
                </li>
                <li className="Ali toolbar_FormSetRf"  style={{ padding: '4px 10px'}}>
                            <a  ref={node=>this.fetchAllBtn=node} style={{display:'flex',marginTop:'5px',cursor: 'pointer'}}  onClick={this.recordFetchAllHandler.bind(this)} title="全取">
                              <i class="icon-container"  style={{width:'20px',background:'url(./images/icons/za-all.svg)',backgroundSize:'96%',marginRight: '5px'}}></i>
                              <span class="menubtnLable" style={{color: 'black',fontSize: '15px'}}>获取全部记录</span>
                            </a>
                </li>
              </div>
    
    
          </div>
    
         )
      
    }else{
      
    return (         
      <div  ref={node=>this.bottombarNode=node} className="datagridcontainer_bottombar" style={{display:'flex',flexDirection:'row',borderLeft:'solid 1px #ddd',borderBottom:'solid 1px #ddd',borderRight:'solid 1px #ddd',minWidth:'321px'}}>
           <label className="datagridcontainer_bottombar_recordnew" ref={node=>this.addBtn=node} style={{marginLeft:'10px',marginTop: '7px',marginBottom: '5px',marginRight: '15px',cursor:'pointer',display:this.props.forLookup?'none':'',width:'20px',background:'url(./images/icons/da-add.svg)',backgroundSize:'110%'}} title="新增" onClick={this.recordNewHandler.bind(this)}></label>
            <label className="datagridcontainer_bottombar_recordsave" ref={node=>this.saveBtn=node} style={{marginTop: '9px',marginBottom: '5px',marginRight: '15px',cursor:'pointer',display:this.props.forLookup?'none':'',width:'18px',background:'url(./images/icons/da-save.svg)',backgroundSize:'100%'}} title="保存" onClick={this.recordSaveHandler.bind(this)}></label>
            <label className="datagridcontainer_bottombar_recorddelelte" ref={node=>this.deleteBtn=node} style={{marginTop: '7px',marginBottom: '5px',marginRight: '15px',cursor:'pointer',display:this.props.forLookup?'none':'',width:'20px',background:'url(./images/icons/da-del.svg)',backgroundSize:'110%'}} title="删除" onClick={this.recordDeleteHandler.bind(this)}></label>
            <a ref={node=>this.reStroeBtn=node} style={{display:'flex',cursor: 'pointer',marginRight:'2px'}} onClick={this.recordRestore.bind(this)}  title="恢复选中记录">
                            <i class="icon-container" style={{width:'25px',background:'url(./images/icons/ze-restore.svg) 0px 7px no-repeat',backgroundSize:'85%',marginRight: '5px'}}></i>
                            {/* <span class="menubtnLable" style={{color: 'black',fontSize: '15px'}}>恢复选中记录</span> */}
                          </a>
            <a ref={node=>this.refreshBtn=node} style={{display:'flex',marginTop:'5px',cursor: 'pointer'}} onClick={this.recordRefreshHandler.bind(this)} title="重新执行查询" >
                            <i ref={node=>this.refreshBtnI=node}  class="icon-container"  style={{width:'25px',background:'url(./images/icons/ze-refsh.svg)  0px 2px ',backgroundSize:'90%',marginRight: '5px',height:'22px'}}></i>
                            {/* <span ref={node=>this.refreshBtnSpan=node}  class="menubtnLable" style={{color: 'black',fontSize: '15px'}}>重新执行查询</span> */}
                          </a>
          <label className="datagridcontainer_bottombar_more" ref={node=>this.moreBtn=node} style={{marginTop: '6px',marginLeft: '-5px',cursor:'pointer',display:this.props.forLookup?'none':'',width:'17px',background:'url(./images/icons/mb-ellipsis-v-filled.svg)'}} title="" onClick={this.dataGridToolbar.bind(this)}></label>
          <label style={{fontWeight:'400','paddingLeft':'10px',marginTop: '10px',marginBottom: '5px',marginRight: '10px',whiteSpace:'nowrap', overflow:'hidden'}} className={'jon-recorder'} ref={node=>this.recordsInfoLabel=node} >{labelContent}</label>
          <label style={{fontWeight:'400','flexGrow':'100','textAlign': 'right','paddingLeft':'20px',paddingRight:'20px',marginTop: '3px',marginBottom: '5px'}} className={'jon-recorder'} ref={node=>this.draggedResultLabel=node} ></label>
          <div className='moreModelBtnsClass' ref={node=>this.moreModelBtns=node} onClick={this.datagridmorebtn.bind(this)} onBlur={this.datagridmorebtn.bind(this)} style={{display:'none',position: 'absolute',bottom: '26px',left: '183px',border: '1px solid #d4d4d4',padding: '10px 0px',backgroundColor: 'white',width:'140px'}}>
            {/* <li className="Ali toolbar_FormSetRf"  style={{ padding: '4px 10px'}}>
                        <a ref={node=>this.reStroeBtnH=node} style={{display:'flex',cursor: 'pointer'}} onClick={this.recordRestore.bind(this)}  title="恢复">
                          <i class="icon-container" style={{width:'20px',background:'url(./images/icons/ze-restore.svg)',backgroundSize:'96%',marginRight: '5px'}}></i>
                          <span class="menubtnLable" style={{color: 'black',fontSize: '15px'}}>恢复选中记录</span>
                        </a>
            </li>
            <li className="Ali toolbar_FormSetRf"  style={{ padding: '4px 10px'}}>
                        <a ref={node=>this.refreshBtnH=node} style={{display:'flex',marginTop:'5px',cursor: 'pointer'}} onClick={this.recordRefreshHandler.bind(this)} title="刷新" >
                          <i ref={node=>this.refreshBtnI=node}  class="icon-container"  style={{width:'20px',background:'url(./images/icons/ze-refsh.svg)',backgroundSize:'96%',marginRight: '5px'}}></i>
                          <span ref={node=>this.refreshBtnSpan=node}  class="menubtnLable" style={{color: 'black',fontSize: '15px'}}>重新执行查询</span>
                        </a>
            </li> */}
            <li className="Ali toolbar_FormSetRf"  style={{ padding: '4px 10px'}}>
                        <a  ref={node=>this.fetchAllBtn=node} style={{display:'flex',marginTop:'5px',cursor: 'pointer'}}  onClick={this.recordFetchAllHandler.bind(this)} title="全取">
                          <i class="icon-container"  style={{width:'20px',background:'url(./images/icons/za-all.svg)',backgroundSize:'96%',marginRight: '5px'}}></i>
                          <span class="menubtnLable" style={{color: 'black',fontSize: '15px'}}>获取全部记录</span>
                        </a>
            </li>
          </div>


      </div>

     )
    }
  }



  render() {
    //<button onClick={this.testShowHide.bind(this)}>测试显示隐藏列</button>
    const rowText = this.state.selectedIndexes.length === 1 ? 'row' : 'rows';
    var _style = Object.assign({},this.props.customStyle);
    _style['position']='relative';
    _style.display = "flex";
    
    if(this.state.visible == false)
      if(this.state.hideInVisible == true)
      {
        _style.display="none"; 
      } 
      else 
      {
        _style.visibility="hidden";
      }
    
    /*var btnsDivStyle={height:'20px'};
    
    btnsDivStyle['bottom']='0.1em';
    btnsDivStyle['display']='flex';
    btnsDivStyle['alignItems']='flex-end';
    btnsDivStyle['flexDirection']= 'row';
    
    var btnxxs={};
    btnxxs['padding']='0em 0.3em';
    btnxxs['flexGrow']='0';
    btnxxs['fontSize']='0.5em';
    btnxxs['marginBottom']='0px';
    var btnnext={};
    btnnext['padding'] = '0em 0.3em 0 0.4em';
    btnnext['flexGrow'] = '0';
    btnnext['fontSize'] = '0.5em';
    btnnext['marginBottom'] = '0px';
    var btnlast = {};
    btnlast['padding'] = '0em 0.4em 0 0.3em';
    btnlast['flexGrow'] = '0';
    btnlast['fontSize'] = '0.5em';
    btnlast['marginBottom'] = '0px';
    var btnsmall = {};
    btnsmall['padding'] = '0em 0.4em';
    btnsmall['flexGrow'] = '0';
    btnsmall['fontSize'] = '0.5em';
    btnsmall['marginBottom'] = '0px';<button className={'btn gridToolBox-btn'} style={btnxxs} onClick={this.recordFirstHandler.bind(this)} title="第一条">
            <i className={'fa fa-fast-backward jon-footer-c'}></i>
          </button>
          <button className={'btn gridToolBox-btn'} style={btnlast} onClick={this.prePageHandler.bind(this)} title="上一页">
            <i className={'fa fa-backward jon-footer-c'}></i>
          </button>
          <button className={'btn gridToolBox-btn'} style={btnnext} onClick={this.nextPageHandler.bind(this)} title="下一页">
            <i className={'fa fa-forward jon-footer-c'}></i>
          </button>
          <button className={'btn gridToolBox-btn'} style={btnxxs} onClick={this.recordLastHandler.bind(this)} title="最末条">
            <i className={'fa fa-fast-forward jon-footer-c'}></i>
          </button>
          <button className={'btn gridToolBox-btn'} style={btnsmall} onClick={this.recordRefreshHandler.bind(this)} title="刷新">
            <i className={'fa fa-refresh jon-footer-c'}></i>
          </button>
         
          <button ref={node=>this.Btnofall = node} className={'btn gridToolBox-btn '} onClick={this.recordFetchAllHandler.bind(this)} title="获取全部" style={{ 'padding':'0 0.4em','flexGrow':'0','fontSize':'0.5em','marginBottom':'0px'}}>
              <i className={'fa  fa-level-down jon-footer-c'} style={{'fontSize':'1.5em'}} ref={node => this.iconFetchAll = node}></i>
          </button>*/
    
    var newSelectIndexes=[];
    var selectedIndexes=this.state.selectedIndexes.slice();
    for(var i=0;i<selectedIndexes.length;i++){
      if(newSelectIndexes.indexOf(selectedIndexes[i])==-1)
        newSelectIndexes.push(selectedIndexes[i]);
    }
    let _minHeight = -1;
    if(this.state.updateMinHeight != -1)
    { 
      _minHeight = this.state.updateMinHeight;
    }

    var labelContent='';
    if(this.bottomBarSettings.obtainRows)
      labelContent+='已获取'+this.state.rows.slice().length+'行';
    if(this.bottomBarSettings.selectedRows){
      if(this.state.rows.slice().length==0){
        labelContent+='，选中'+0+'行';
      }else{
        labelContent+='，选中'+newSelectIndexes.length+'行';
      }
    }
    if(this.bottomBarSettings.allRows)
    {

    }
    _style.flexDirection = "column";
    /*let _rowHeight = FormItemConst.DATAGRID_ROW_HEIGHT;
    for(let i in this._columns)
    {
      let _column = this._columns[i];
      if(_column.columnDisplayHeight && _column.columnDisplayHeight>_rowHeight)
        _rowHeight = _column.columnDisplayHeight;

    }*/
    /*if(this.state.heightAddon!=0 && typeof(_style.height)=="string" && _style.height.indexOf("px") != -1)
    {
      let intHeight = parseInt(_style.height.substring(0,_style.height.length-2));
      _style.height = (intHeight+this.state.heightAddonDiffer)+"px";
      this.containerFixedHeight = _style.height;
      this.grid.parentDivUpdateHeight = true;
      this.state.heightAddon = 0;
    }*/
    /*else if(this.state.heightAddon != 0 && this.datagridContainer.style && this.datagridContainer.style.height)
    {
      let intHeight = parseInt(this.datagridContainer.style.height.substring(0,this.datagridContainer.style.height.length-2));
      _style.height = (intHeight+this.state.heightAddon)+"px";
      this.grid.parentDivUpdateHeight = true;
      this.state.heightAddon = 0;
    }*/
    /*else if(this.state.heightAddon != 0)
    {
      _style.height = $(this.datagridContainer).height()+this.state.heightAddon+"px";
      this.grid.parentDivUpdateHeight = true;
      this.containerFixedHeight = _style.height;
      this.state.heightAddon = 0;
    }*/

    if(this.containerFixedHeight)// && this.props.customStyle && this.props.customStyle.hasOwnProperty("height"))
    {
      _style.height = this.containerFixedHeight+"px";
      if(this.grid)this.grid.parentDivUpdateHeight = true;
    }

    //如果是由于dividedBox分隔拖动导致DataGrid的高度发生变化 则 暂时以此为最高优先级 高于GOT设置固定高度等
    /*if(this.dividedBoxSplitFixedHeight)
    {
      _style.height = this.dividedBoxSplitFixedHeight;
    }*/

    let headerHeightPro = this.props.headerRowHeightPro;
    let _headerRowHeight;
    if(headerHeightPro == "Row")
    {
      _headerRowHeight = this.props.rowHeight?this.props.rowHeight:FormItemConst.DATAGRID_HEADER_HEIGHT;
    }
    else
    {
      _headerRowHeight = FormItemConst.DATAGRID_HEADER_HEIGHT;
    }

    let _parentWindow = window.hasOwnProperty("userInfos")?window:window.parent.window;
    let userSettingEntry = _parentWindow.userSettingEntry;
    let pressEdit = false;
    if(userSettingEntry)
    {
      pressEdit = userSettingEntry.pressEditList;
    }
    let lastcursorStyle = {cursor:'pointer',position:'absolute',bottom:'22px',right:'0px',width:'9px',height:'16px',background:'url(images/DataGridToolBar2.png)',backgroundPositionX:'-384px',display:'none'};
    if(!this.props.showToolbar){
      lastcursorStyle = {cursor:'pointer',position:'absolute',bottom:'0px',right:'0px',width:'9px',height:'16px',marginBottom:'0px',background:'url(images/DataGridToolBar2.png)',backgroundPositionX:'-384px',display:'none'};
    }
    let refishMinHeight=false;
    if(this.state['radioRef']){
      refishMinHeight=true;
    }
    //_style.alignSelf='stretch';_style.flexGrow = 100;
    //onMouseDown={this.onMouseDownHandler.bind(this)}
    //  <div style={{display:'flex',flex:'100 0 auto',flexDirection:'column',alignItems:'flex-start',alignSelf:'stretch',justifyContent:'flex-start'}}> </div>

    let _bottomBar=this.bottomToolBar(labelContent,false);
    if(document.getElementById(this.props.xml.name) && document.getElementById(this.props.xml.name).offsetWidth){
      _bottomBar=this.bottomToolBar(labelContent,true);
    }

    return  (

        <div className={'datagridcontainer'} style={_style} onFocus={this.testOnFocus.bind(this)}
          ref={node=>this.datagridContainer = node} id={this.props.xml.name} data-xmlid={this.props.xml.id}
          onClick={this.onMouseDownHandler.bind(this)}
          onWheel={this.onMouseWheel.bind(this)}
          onTouchMove={this.onMouseWheel.bind(this)}
          onTouchStart={this.onTouchStartHandler.bind(this)}
          onTouchEnd={this.onTouchEndHandler.bind(this)}>
          <ReactDataGrid
          onCellsDragged = {this.onCellsVerticalDragged.bind(this)}
          onDragHandleDoubleClick = {this.onDragHandleDoubleClick.bind(this)}
          numColumn={true}
          numColumnKeyId = {this.props.xml.id}
          ref={ node => this.grid = node }
          onRowClick={this.rowClick.bind(this)}
          onRowDragStart={this.onRowDragStart.bind(this)}
          onGridKeyDown={this.gridKeyDown.bind(this)}
          rowKey="id"
          columns={this.state.columns}
          enableCellSelect={true}
          rowGetter={this.rowGetter.bind(this)}
          rowsCount={this.state.rows.length}
          rowHeight={this.props.rowHeight?this.props.rowHeight:FormItemConst.DATAGRID_ROW_HEIGHT}
          headerRowHeight={_headerRowHeight}
          onGridRowsUpdated={this.handleGridRowsUpdated.bind(this)}
          onCellSelected={this.onGridCellSelected.bind(this)}
          onScroll={this.scrolling.bind(this)}
          resizeUpdateAssist={this.resizeUpdateAssist.bind(this)}
          //TODO 原来是直接使用minHeight为-1 到ReactDataGrid的render中去计算高度 在如采购订单(有两个flexShrik为0的div)这样的画面上计算不准确
          //现在改为不适用minHeight minHeight只设置两行 可能对其余情况有影响 需要再行观察
          //minHeight={FormItemConst.DATAGRID_HEADER_HEIGHT+(this.props.rowHeight?this.props.rowHeight:FormItemConst.DATAGRID_ROW_HEIGHT)}

          //TODO由于ReactDataGrid源代码中是以null来判断有误cellCopyPaste功能 所以此处必须传入null 否则默认会被定义为有
          //启用该功能会导致rowData及props的value在项目编辑器存在的情况下被改变 导致无法触发modified相关开发方法
          onCellCopyPaste = {null}
          minHeight={_minHeight}
          cellNavigationMode={"loopOverRow"}
          holeCustomTab = {!this.props.forLookup}
          onTab={this.onTab.bind(this)}
          holeCustomEnter = {true}
          onEnter = {this.onEnter.bind(this)}
          onHeaderCellMove={this.onHeaderCellMove.bind(this)}
          onDoubleClickToFit={this.onHeaderDragHandleDoubleClick.bind(this)}
          containerWidth100={true}
          pressEdit={pressEdit}

          refishMinHeight={refishMinHeight}
          rowSelection={{
            showCheckbox: false,
            enableShiftSelect: true,
            onRowsSelected: this.onRowsSelected.bind(this),
            onRowsDeselected: this.onRowsDeselected.bind(this),
            selectBy: {
              indexes: this.state.selectedIndexes
            }

          }} 
            />
          <label ref={node=>this.recordFirstBtn=node} onClick={this.recordFirstHandler.bind(this)} style={{cursor:'pointer',position:'absolute',top:'14px',right:'0px',width:'9px',height:'16px',background:'url(images/DataGridToolBar2.png)',backgroundPositionX:'-356px',display:'none'}} title="第一条"></label>
          <label ref={node=>this.recordLastBtn=node} onClick={this.recordLastHandler.bind(this)} style={lastcursorStyle} title="最末条"></label>
          {/* <div  ref={node=>this.bottombarNode=node} className="datagridcontainer_bottombar" style={{display:'flex',flexDirection:'row',borderLeft:'solid 1px #ddd',borderBottom:'solid 1px #ddd',borderRight:'solid 1px #ddd',minWidth:'321px'}}> */}

            {/* <label ref={node=>this.refreshBtn=node} className="datagridcontainer_bottombar_refresh" style={{marginTop: '7px',marginBottom: '5px',marginRight: '10px',marginLeft:'5px',cursor:'pointer',width:'15px',height:'16px',background:'url(images/DataGridToolBar2.png)'}} onClick={this.recordRefreshHandler.bind(this)} title="刷新"></label> */}

            {/*<label className="datagridcontainer_bottombar_recordfirst" style={{marginTop: '7px',marginBottom: '5px',marginRight: '10px',marginLeft:'5px',cursor:'pointer',width:'15px',height:'16px',background:'url(images/DataGridToolBar2.png)',backgroundPositionX:'-357px',marginLeft:'0px',marginRight:'8px'}} onClick={this.recordFirstHandler.bind(this)} title="第一条"></label>
            <label className="datagridcontainer_bottombar_recordlast" style={{marginTop: '7px',marginBottom: '5px',marginRight: '10px',marginLeft:'5px',cursor:'pointer',width:'15px',height:'16px',background:'url(images/DataGridToolBar2.png)',backgroundPositionX:'-385px',marginLeft:'0px'}} onClick={this.recordLastHandler.bind(this)} title="最末条"></label>*/}

            {/* <label ref={node=>this.fetchAllBtn=node} className="datagridcontainer_bottombar_recordall" style={{marginTop: '7px',marginBottom: '5px',marginRight: '10px',cursor:'pointer',width:'17px',height:'16px',background:'url(./images/DataGridToolBar2.png)',backgroundPositionX:'-33px'}} onClick={this.recordFetchAllHandler.bind(this)} title="全取"></label> */}


          {/* </div> */}
              {_bottomBar}
        </div>
    );
  }
}

FormItemDataGrid.defaultProps = {
};

module.exports = FormItemDataGrid;


// WEBPACK FOOTER //
// ./src/formItem/FormItemDataGrid.js